"use strict"
if (typeof Rs === "undefined") {
  var Rs = {}
  Rs.ReplacementText = {
    placeholderToReplacementTextMap: {
      RS_PRODUCT_CALL_TO_ORDER_MESSAGE: "Call to order!",
      RS_PRODUCT_DROPSHIP_DELIVERY: "Get it within 2-4 weeks",
      RS_PRODUCT_PERSONALIZATION_DELIVERY: "Get it within 2-4 weeks",
      RS_PRODUCT_ELECTRONIC_DELIVERY: "FREE Electronic Delivery",
      RS_PRODUCT_ERROR_MESSAGE: "",
      RS_PRODUCT_FASTER_SHIPPING_LABEL: "Faster Shipping",
      RS_PRODUCT_FREE_SHIPPING_LABEL_DAY: "-Day",
      RS_PRODUCT_FREE_SHIPPING_LABEL_END: "Shipping",
      RS_PRODUCT_FREE_SHIPPING_LABEL_START: "Free",
      RS_PRODUCT_INVENTORY_OUT_OF_STOCK: "More On The Way",
      RS_PRODUCT_INVENTORY_OUT_OF_STOCK_PREORDER: "Preorder Today",
      RS_PRODUCT_INVENTORY_LOW_STOCK_START: "Only",
      RS_PRODUCT_INVENTORY_LOW_STOCK_END: "Left",
      RS_PRODUCT_LOADING_MESSAGE: "Loading ...",
      RS_PRODUCT_PRICE_LABEL: "",
      RS_PRODUCT_MIN_PRICE_LABEL: "From",
      RS_PRODUCT_SHIPPING_GET_IT_BY_LABEL: "Get it by",
      RS_PRODUCT_SHIPPING_ORDER_BY_LABEL: "when you order within",
      RS_PRODUCT_ITEM_QTY_SELECT_LABEL: "Quantity",
      RS_SESSION_PHONE_LABEL: "",
      RS_SESSION_WEBCODE_LABEL: "Cart ID:",
      RS_SESSION_ZIP_CODE_LABEL: "Shipping to",
      RS_SESSION_ZIP_SUBMISSION_INSTRUCTION_LABEL: "Shipping To",
      RS_SESSION_ZIP_SUBMISSION_PLACEHOLDER_LABEL: "Zip Code",
      RS_SESSION_ZIP_SUBMISSION_SUBMIT_LABEL: "update",
      RS_SESSION_VIEW_CART_BUTTON_LABEL: "View Cart",
      RS_SESSION_CONTINUE_SHOPPING_BUTTON_LABEL: "Continue Shopping",
      RS_SESSION_ITEM_ADDED_TO_CART_TEXT:
        "You&#039;ve added an item to the cart!",
      RS_SESSION_MINI_CART_HEADER_ITEM_ADDED: "Item added to cart",
      RS_SESSION_MINI_CART_CAROUSEL_ADDED_LABEL: "Added",
      RS_SESSION_MINI_CART_CAROUSEL_ARIA_LABEL: "Related items carousel",
      RS_PRODUCT_NOTIFY_ME_OUT_OF_STOCK_LINK:
        "Notify me when this item is in stock",
      RS_PRODUCT_NOTIFY_ME_PREORDER_LINK:
        "Notify me when this item is in stock",
      RS_PRODUCT_NOTIFY_ME_IN_STOCK_LINK:
        "Notify me about updates to this item",
      RS_PRODUCT_NOTIFY_ME_MODAL_LABEL: "Notify Me!",
      RS_PRODUCT_NOTIFY_ME_OUT_OF_STOCK_FORM_LABEL:
        "Enter your email to be notified when this item is back in stock:",
      RS_PRODUCT_NOTIFY_ME_PREORDER_FORM_LABEL:
        "Enter your email to be notified when this item is in stock:",
      RS_PRODUCT_NOTIFY_ME_IN_STOCK_FORM_LABEL:
        "Enter your email to be notified about price drops or low stock:",
      RS_PRODUCT_NOTIFY_ME_NEWSLETTER_LABEL:
        "Also sign me up for marketing emails",
      RS_PRODUCT_NOTIFY_ME_SUBMIT_LABEL: "Submit",
      RS_PRODUCT_NOTIFY_ME_EMAIL_PLACEHOLDER_LABEL: "Email address",
      RS_PRODUCT_NOTIFY_ME_ACCORDION_SUBSCRIBED: "Subscribed to notifications",
      RS_PRODUCT_NOTIFY_ME_FIRST_NAME_PLACEHOLDER_LABEL: "First Name",
      RS_PRODUCT_NOTIFY_ME_LAST_NAME_PLACEHOLDER_LABEL: "Last Name",
      RS_PRODUCT_NOTIFY_ME_PHONE_PLACEHOLDER_LABEL: "Phone number",
      RS_PRODUCT_NOTIFY_ME_OUT_OF_STOCK_SIGNUP_MESSAGE:
        "Sign me up to be notified when this item is back in stock:",
      RS_PRODUCT_NOTIFY_ME_PREORDER_SIGNUP_MESSAGE:
        "Sign me up to be notified when this item is in stock:",
      RS_PRODUCT_NOTIFY_ME_IN_STOCK_SIGNUP_MESSAGE:
        "Sign me up to be notified about price drops or low stock:",
      RS_PRODUCT_NOTIFY_ME_FIRST_NAME_FORM_LABEL: "First Name:",
      RS_PRODUCT_NOTIFY_ME_LAST_NAME_FORM_LABEL: "Last Name:",
      RS_PRODUCT_NOTIFY_ME_PHONE_FORM_LABEL: "Notify me by SMS:",
      RS_PRODUCT_NOTIFY_ME_EMAIL_FORM_LABEL: "Notify me by email:",
      RS_PRODUCT_ADD_TO_CART_SUBMIT_BUTTON_LABEL: "Add to Cart",
      RS_SESSION_USER_LOGGED_IN_LINK_LABEL: "{rs_user_name}",
      RS_SESSION_USER_LOG_OUT_LINK_LABEL: "Log Out",
      RS_SESSION_USER_NOT_LOGGED_IN_LINK_LABEL: "Log In / Create Account",
    },
  }
  Rs.ConfigValues = { notify_me_sms_enabled: false }
  Rs.t = function (r) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", r)
    } else {
      r()
    }
  }
  Rs.i = "v3"
  Rs.o = {
    l: function (t, i) {
      var n =
        HTMLElement.prototype.matches ||
        HTMLElement.prototype.msMatchesSelector ||
        HTMLElement.prototype.webkitMatchesSelector ||
        HTMLElement.prototype.mozMatchesSelector
      var s = function (r) {
        if (!(r instanceof HTMLElement)) {
          return
        }
        if (n.call(r, t)) {
          r.dispatchEvent(Rs.Events.createEvent(i))
        }
        for (var e = 0; e < r.children.length; e++) {
          s(r.children[e])
        }
      }
      if (!window.MutationObserver) {
        document.addEventListener("DOMNodeInserted", function (r) {
          s(r.target)
        })
        return
      }
      var r = new MutationObserver(function (r) {
        r.forEach(function (r) {
          var e = r.addedNodes
          if (e === null || e.length === 0) {
            return
          }
          for (var t = 0; t < e.length; t++) {
            s(e[t])
          }
        })
      })
      var e = {}
      e["attributes"] = false
      e["childList"] = true
      e["subtree"] = true
      r.observe(document.getElementsByTagName("body")[0], e)
    },
  }
  Rs.u = {
    l: function (r, e, t) {
      var i = function (r) {
        r.dispatchEvent(Rs.Events.createEvent(t))
      }
      if (!window.MutationObserver) {
        document.addEventListener("DOMAttrModified", function (r) {
          i(r.target)
        })
        return
      }
      var n = new MutationObserver(function (r) {
        r.forEach(function (r) {
          i(r.target)
        })
      })
      n.observe(r, { attributes: true, attributeFilter: [e] })
    },
  }
  Rs.p = {
    _: 1e3,
    v: 1001,
    R: 2e3,
    I: 2001,
    O: 2002,
    S: 2003,
    T: 2004,
    h: 2005,
    A: 2006,
    N: 2007,
    m: 2008,
    C: 2009,
    P: 2010,
    L: 3e3,
    D: 3001,
    M: 3002,
    g: 4e3,
    U: 4001,
    F: 4002,
    B: 4003,
    H: 4004,
    W: 4005,
    k: 4006,
    V: 4007,
    G: 4008,
    Y: 4009,
    Z: 4010,
    j: 4011,
    K: 4012,
    q: 4013,
    X: 4014,
    J: 4015,
    $: 4016,
    rr: 4017,
    er: 4018,
    tr: 4019,
    ir: 4020,
    nr: 4021,
    sr: 4022,
    ar: 4023,
    lr: 4024,
    ur: 4025,
    dr: 4026,
    cr: 4027,
    pr: 4500,
    _r: 5e3,
    vr: 5001,
    Rr: 5002,
    Ir: 5003,
    Or: 5004,
    Sr: 5005,
    Er: 5006,
    Tr: 5007,
    hr: 5008,
    Ar: 5009,
    Nr: 5010,
    mr: 5011,
    Cr: 5012,
    Pr: 5013,
    Lr: 6e3,
    Dr: 6001,
    yr: 6002,
    Mr: 6003,
    br: 7e3,
    gr: 7001,
  }
  Rs.Events = {
    POPULATE_SESSION_ELEMENTS: "rsEventPopulateSessionElements",
    UPDATE_COOKIE_CONSENT_SETTINGS: "rsEventUpdateCookieConsentSettings",
    POPULATE_PRODUCT_OFFER_CONTAINER: "rsEventPopulateProductOfferContainer",
    POPULATE_PRODUCT_AGGREGATE_CONTAINER:
      "rsEventPopulateProductAggregateContainer",
    HIDE_IF_ITEM_UNORDERABLE: "rsEventHideIfItemUnorderable",
    PRODUCT_OFFER_CONTAINER_CART_FORM_ADDED:
      "rsProductOfferContainerCartFormAdded",
    INITIALIZE_CHANGE_ITEM_FORM: "rsEventInitializeChangeItemForm",
    UPDATE_PRODUCT_OFFER_CONTAINER_WITH_NEW_ITEM:
      "rsEventUpdateProductOfferContainerWithNewItem",
    ZIP_CODE_UPDATED: "rsEventZipCodeUpdated",
    INITIALIZE_NOTIFY_ME_MODAL: "rsEventInitializeNotifyMeModal",
    POPULATE_NOTIFY_ME_MODAL_CONTAINER: "rsEventPopulateNotifyMeModalContainer",
    UPDATE_MODAL_STATE_CLOSE: "rsEventUpdateModalStateClose",
    createEvent: function (r) {
      if (typeof Event === "function") {
        return new Event(r, { bubbles: true })
      }
      var e = document.createEvent("Event")
      e.initEvent(r, true, false)
      return e
    },
  }
  Rs.Ur = function (r) {
    var t = this,
      f = r,
      c = f.querySelector(".rsPopoverTriangle"),
      i = new Rs.wr(),
      p = f.classList.contains("rsAutoPosition")
    var n = function (r) {
      if (!r || !p) {
        return false
      }
      var e = r.offsetLeft + r.offsetWidth / 2,
        t = f.getBoundingClientRect(),
        i = f.offsetLeft + f.offsetWidth / 2,
        n = e - i,
        s = f.offsetLeft + n,
        a = c ? c.offsetWidth * Math.sqrt(2) : 0,
        o = c ? c.offsetLeft + a / 2 : 0,
        l = e - o,
        u = c ? c.offsetLeft + l + s * -1 : 0,
        d = 0
      if (t.left + n < 0) {
        d = Math.abs(t.left + n)
        s += d
        u -= d
      } else if (t.right + n > document.body.clientWidth) {
        d = Math.abs(t.right + n) - document.body.clientWidth
        s -= d
        u += d
      }
      return { Fr: Math.round(s), Br: Math.round(u) }
    }
    this.open = function (r) {
      i.Hr(f)
      var e
      var t = f.getAttribute("data-rs-popover-trigger-element-id")
      if (t) {
        document.getElementById(t).setAttribute("aria-expanded", "true")
      }
      if (false !== (e = n(r))) {
        f.style.left = e.Fr + "px"
        if (c) {
          c.style.left = e.Br + "px"
        }
      }
    }
    this.close = function () {
      i.Wr(f)
      var r = f.getAttribute("data-rs-popover-trigger-element-id")
      if (r) {
        document.getElementById(r).setAttribute("aria-expanded", "false")
      }
    }
    this.kr = function (r) {
      if (r.key === "Enter") {
        this.close()
      }
    }
    this.Vr = function (r) {
      if (r.key === " ") {
        this.close()
      }
    }
    var e = f.querySelectorAll(".rsPopoverClose")
    for (var s = 0; s < e.length; s++) {
      e[s].addEventListener("click", t.close)
      e[s].addEventListener("keydown", t.kr)
      e[s].addEventListener("keyup", t.Vr)
    }
    document.addEventListener(
      "click",
      function (r) {
        const e = document.getElementById(f.id)
        if (e !== null && !f.contains(r.target)) {
          t.close()
        }
      },
      true
    )
  }
  Rs.wr = function () {
    var o = this
    var i = function (r, e, t, i) {
      var n = o.Gr(r, e)
      if (n) {
        var s = n.classList
        if (s.contains(i)) {
          return
        }
        if (!s.contains(t)) {
          s.add(i)
          return
        }
        if (typeof s.replace === "function") {
          s.replace(t, i)
        } else {
          var a = new RegExp("(?:^|\\s)" + t + "(?!\\S)", "g")
          n.className = n.className.replace(a, "") + " " + i
        }
      }
    }
    this.Gr = function (r, e) {
      if (!e) {
        return r
      }
      var t = r.querySelector(e)
      if (typeof t !== "undefined" && t !== null) {
        return t
      }
      return false
    }
    this.Hr = function (r, e) {
      i(r, e, "rsHidden", "rsVisible")
      var t = o.Gr(r, e)
      if (t) {
        t.setAttribute("aria-hidden", "false")
      }
    }
    this.Wr = function (r, e) {
      i(r, e, "rsVisible", "rsHidden")
      var t = o.Gr(r, e)
      if (t) {
        t.setAttribute("aria-hidden", "true")
      }
    }
    this.Yr = function (r, e, t, i) {
      var n = o.Gr(r, e)
      if (n) {
        n.innerHTML = t
        if (i) {
          i(n)
        }
      } else {
      }
    }
    this.zr = function () {
      return (
        "https://shop.skbcases.com/cart--" +
        Math.floor(1e3 + Math.random() * 9e3)
      )
    }
  }
  Rs.Zr = function () {
    var t = null,
      l = "RS" + Rs.i + ":"
    var u = function (r, e, t) {
      var i = {}
      i["expiration"] = new Date(Date.now() + t * 1e3)
      i["apiResponse"] = e
      localStorage.setItem(r, JSON.stringify(i))
    }
    var d = function (r) {
      localStorage.removeItem(r)
    }
    var f = function () {
      var e = null,
        t = null,
        i = new Date(),
        n = null,
        s = null,
        a = false
      Object.keys(localStorage).forEach(function (r) {
        e = o(r)
        if (!e) {
          return
        }
        if (i >= e["expiration"]) {
          d(r)
          a = true
          return
        }
        t = e["expiration"]
        if (!n || t < n) {
          n = t
          s = r
        }
      })
      if (!a && s) {
        d(s)
      }
    }
    var o = function (e) {
      if (e.lastIndexOf(l, 0) !== 0) {
        return
      }
      var r = localStorage.getItem(e)
      if (!r) {
        return
      }
      var t
      try {
        t = JSON.parse(r)
      } catch (r) {
        d(e)
        return
      }
      if (
        typeof t["expiration"] === "undefined" ||
        typeof t["apiResponse"] === "undefined"
      ) {
        d(e)
        return
      }
      t["expiration"] = new Date(t["expiration"])
      return t
    }
    this.jr = function () {
      if (t !== null) {
        return t
      }
      var r = function () {
        var r = l + "tempkey"
        try {
          localStorage.setItem(r, "tempval")
          localStorage.removeItem(r)
          return true
        } catch (r) {
          return false
        }
      }
      if (r()) {
        t = true
        return t
      }
      try {
        f()
      } catch (r) {}
      var e = r()
      if (!e) {
        Rs.Qr.send(Rs.p.L)
      }
      t = e
      return t
    }
    this.getItem = function (r) {
      if (!this.jr()) {
        var e = {}
        e["function"] = "getItem"
        Rs.Qr.send(Rs.p.D, e)
        return null
      }
      r = l + r
      var t = o(r)
      if (!t) {
        return null
      }
      if (new Date() >= t["expiration"]) {
        d(r)
        return null
      }
      return t["apiResponse"]
    }
    this.setItem = function (r, e, t) {
      var i = {}
      if (!this.jr()) {
        i["function"] = "setItem"
        Rs.Qr.send(Rs.p.D, i)
        return
      }
      r = l + r
      if (localStorage.getItem(r)) {
        d(r)
      }
      var n = false,
        s,
        a
      for (var o = 0; o < 3; o++) {
        try {
          u(r, e, t)
          n = true
          break
        } catch (r) {
          s = r
          try {
            f()
          } catch (r) {
            a = r
          }
        }
      }
      if (!n) {
        i["parsedResponseToSave"] = e
        i["cacheKey"] = r
        i["caughtError1"] = s
        i["caughtError2"] = a
        i["numLocalStorageEntries"] = Object.keys(localStorage).length
        Rs.Qr.send(Rs.p.M, i)
      }
    }
  }
  Rs.Kr = new (function () {
    var u = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (r) {
        var e = (Math.random() * 16) | 0,
          t = r == "x" ? e : (e & 3) | 8
        return t.toString(16)
      }
    )
    this.qr = function (i, r, e, n, s, a, o) {
      var t = new XMLHttpRequest()
      t.onload = function () {
        if (this.status !== 200) {
          if (a) {
            a(o, { httpStatus: this.status, body: this.responseText })
          }
          return
        }
        var r,
          e = {}
        try {
          r = JSON.parse(this.responseText)
        } catch (r) {
          e["rawResponse"] = this.responseText
          e["apiUrl"] = i
          e["caughtError"] = r
          Rs.Qr.send(Rs.p.v, e)
          if (a) {
            a(o)
          }
          return
        }
        var t = n(r)
        if (t !== true) {
          e = {}
          e["apiUrl"] = i
          e["parsedResponse"] = r
          Rs.Qr.send(t, e)
          if (a) {
            a(o)
          }
          return
        }
        if (s) {
          s(r, o)
        }
      }
      t.onerror = function () {
        if (a) {
          a(o)
        }
      }
      t.open(
        r,
        "https://shop.skbcases.com" +
          i +
          (i.indexOf("?") !== -1 ? "&" : "?") +
          "pvid=" +
          u
      )
      t.withCredentials = true
      if (r === "POST") {
        var l = new FormData()
        Object.keys(e).forEach(function (r) {
          l.append(r, e[r])
        })
        t.send(l)
      } else {
        t.send()
      }
    }
    this.Xr = function () {
      return u
    }
  })()
  Rs.Jr = {
    $r: ["performance", "functional", "targeting"],
    cookieConsentSettings: {},
    re: "data-rs-cookie-consent",
    ee: false,
    init: function (e, r) {
      if (!Rs.Jr.ee) {
        document.addEventListener(
          Rs.Events.UPDATE_COOKIE_CONSENT_SETTINGS,
          Rs.Jr.te
        )
        Rs.Jr.ee = true
      }
      Rs.Jr.$r.forEach(function (r) {
        Rs.Jr.cookieConsentSettings[r] = parseInt(e[r])
      })
      if (r) {
        Rs.Jr.ie(e, r)
        Rs.u.l(r, Rs.Jr.re, Rs.Events.UPDATE_COOKIE_CONSENT_SETTINGS)
        r.dispatchEvent(
          Rs.Events.createEvent(Rs.Events.UPDATE_COOKIE_CONSENT_SETTINGS)
        )
      }
    },
    ie: function (e, r) {
      if (r.hasAttribute(Rs.Jr.re) && r.getAttribute(Rs.Jr.re) !== "") {
        return
      }
      var t = []
      Rs.Jr.$r.forEach(function (r) {
        t.push(r + "=" + e[r])
      })
      r.setAttribute(Rs.Jr.re, t.join(","))
    },
    te: function (r) {
      if (r.hasOwnProperty("cookieConsentSettings")) {
        Rs.Jr.ne(r["cookieConsentSettings"])
        return
      }
      Rs.Jr.ne(Rs.Jr.se(r.target.getAttribute(Rs.Jr.re)))
    },
    se: function (i) {
      var n = {}
      Rs.Jr.$r.forEach(function (r) {
        var e = new RegExp(r + "=(0|1)"),
          t = i.match(e)
        if (t) {
          n[r] = parseInt(t[1])
        } else {
          n[r] = Rs.Jr.cookieConsentSettings[r]
        }
      })
      return n
    },
    ne: function (t) {
      var i = false
      Rs.Jr.$r.forEach(function (r) {
        if (!t.hasOwnProperty(r)) {
          return true
        }
        var e = parseInt(t[r])
        if ([0, 1].indexOf(e) !== -1 && e !== Rs.Jr.cookieConsentSettings[r]) {
          i = true
          Rs.Jr.cookieConsentSettings[r] = e
        }
      })
      if (!i) {
        return
      }
      Rs.Kr.qr(
        "/rs/api/" + Rs.i + "/sessions/cookie-consent",
        "POST",
        Rs.Jr.cookieConsentSettings,
        function (r) {
          return Array.isArray(r) && !r.length
        }
      )
    },
  }
  Rs.ae = new (function () {
    var e = new Rs.Zr(),
      t = "zip-code",
      i = 3600,
      n = null,
      a = null,
      s = this
    var r = function () {
      if (!e.jr()) {
        return null
      }
      return e.getItem(t)
    }
    var o = function (r) {
      if (!e.jr()) {
        return
      }
      e.setItem(t, r, i)
    }
    var l = function (r) {
      if (r === s.oe()) {
        a.close()
        a.le()
        return
      }
      Rs.Kr.qr(
        "/rs/api/" + Rs.i + "/sessions/zip",
        "POST",
        { zip: r },
        Rs.de.ue,
        c,
        u,
        s
      )
    }
    var u = function (r, e) {
      var t = document.getElementById("rsZipCodeModalError"),
        i = a.fe().querySelector(".rsZipCodeModalInput"),
        n = {},
        s = false
      if (t !== null) {
        return
      }
      if (i !== null) {
        i.setAttribute("aria-invalid", "true")
      }
      try {
        n = JSON.parse(e.body)
      } catch (r) {
        return
      }
      if (!n.hasOwnProperty("message") || n.message.length === 0) {
        return
      }
      s = a.ce(
        a.pe("div", {
          id: "rsZipCodeModalError",
          className: "rsZipCodeModalError rsModalError",
          textContent: n.message,
        })
      )
      if (i !== null && s) {
        i.setAttribute("aria-describedby", "rsZipCodeModalError")
      }
    }
    var d = function () {
      return document.querySelectorAll(".rsZipCode")
    }
    var f = function (r, e) {
      var t = d(),
        i = s._e(r, e)
      for (var n = 0; n < t.length; n++) {
        t[n].innerHTML = i
      }
    }
    var c = function (r) {
      a.close()
      a.le()
      s.ve(r["zip"])
      f(r["zip"], r["city"])
    }
    var p = function () {
      if (a === null) {
        return
      }
      var r = a.fe().querySelector(".rsZipCodeModalForm")
      if (r === null) {
        return
      }
      r.addEventListener("submit", function (r) {
        r.preventDefault()
        var e = new FormData(r.target),
          t = e.get("zip")
        if (t) {
          l(t)
        }
      })
    }
    var _ = function () {
      if (a !== null) {
        a.open()
      }
    }
    var v = function (r) {
      if (r.key === "Enter" || r.key === "Space") {
        _()
      }
    }
    this.oe = function () {
      if (n === null) {
        n = r()
      }
      return n
    }
    this.ve = function (r) {
      var e = s.oe()
      if (r !== e) {
        n = r
        o(r)
        if (e !== null) {
          document.dispatchEvent(
            Rs.Events.createEvent(Rs.Events.ZIP_CODE_UPDATED)
          )
        }
      }
    }
    this._e = function (r, e) {
      if (r === null) {
        return "(enter your zip code)"
      }
      return r + (e ? " (" + e + ")" : "")
    }
    this.Re = function () {
      var r = document.querySelector(".rsZipCodeModalWrapper")
      if (r !== null) {
        a = new Rs.Ie(r)
        p()
      }
    }
    this.Oe = function () {
      var r = d()
      if (r.length === 0) {
        return
      }
      for (var e = 0; e < r.length; e++) {
        r[e].addEventListener("click", _)
        r[e].addEventListener("keydown", v)
      }
    }
  })()
  Rs.de = {
    ue: function (r) {
      if (typeof r !== "object") {
        return Rs.p.Lr
      }
      if (
        typeof r["zip"] === "undefined" ||
        (r["zip"] !== null && typeof r["zip"] !== "string")
      ) {
        return Rs.p.Mr
      }
      if (
        typeof r["city"] === "undefined" ||
        (r["city"] !== null && typeof r["city"] !== "string")
      ) {
        return Rs.p.yr
      }
      return true
    },
  }
  Rs.Se = function () {
    var i = null,
      n = this,
      s = null,
      a = null
    this.Ee = function (r) {
      s = o(r)
      var e = s !== null || r.classList.contains("rsNoGoToCart")
      if (!e) {
        return
      }
      if (s !== null && i === null) {
        l()
        if (i === null) {
          Rs.Qr.send(Rs.p.P, { modalType: s })
          return
        }
      }
      r.removeEventListener("submit", t)
      r.addEventListener("submit", t)
    }
    this.addItemsToCart = function (r, e, t, i) {
      var n = {}
      r.forEach(function (e, t) {
        Object.keys(e).forEach(function (r) {
          n[r + t] = e[r]
        })
      })
      if (s === "minicart") {
        n["rsUseMiniCartModal"] = true
      }
      if (
        typeof i === "object" &&
        i.hasOwnProperty("updateQty") &&
        i["updateQty"]
      ) {
        n["updateQty"] = true
      }
      Rs.Kr.qr(
        "/rs/api/" + Rs.i + "/sessions/cart",
        "POST",
        n,
        Rs.Te.ue,
        e,
        null,
        i
      )
    }
    var t = function (r) {
      r.preventDefault()
      var e = r.target,
        t = {},
        i = new FormData(e)
      i.forEach(function (r, e) {
        t[e] = r
      })
      n.addItemsToCart([t], n.he, null, { cartForm: e })
    }
    var o = function (r) {
      if (r.classList.contains("rsWithMiniCartModal")) {
        return "minicart"
      }
      if (r.classList.contains("rsWithContinueShoppingModal")) {
        return "continueshopping"
      }
      return null
    }
    this.he = function (r, e) {
      const t = typeof e["cartForm"] !== "undefined" ? e["cartForm"] : null
      if (t && null !== o(t.parentElement) && i !== null) {
        if (s === "minicart") {
          if (a === null) {
            a = new Rs.Ae(i, n)
          }
          a.Re(r, t)
        }
        i.open()
        i.Ne()
        if (s === "minicart") {
          a.me()
        }
      }
      n.Ce(r["cart"])
    }
    this.Ce = function (r) {
      var e = document.querySelectorAll(".rsCartCount")
      for (var t = 0; t < e.length; t++) {
        e[t].innerHTML = r["count"]
        var i = e[t].closest(".rsMiniCartSummary")
        if (i !== null && i.contains(e[t])) {
          e[t].innerHTML += r["count"] > 1 ? " Items" : " Item"
        }
      }
    }
    this.Pe = function (r, e) {
      i.fe().querySelector(r).innerHTML = "$" + e["subtotal"]
    }
    var l = function () {
      if (i === null) {
        var r = null
        if (s === "minicart") {
          r = document.querySelector(".rsMiniCartModalWrapper")
        } else if (s === "continueshopping") {
          r = document.querySelector(".rsContinueShoppingModalWrapper")
        }
        if (r !== null) {
          i = new Rs.Ie(r)
        }
      }
    }
  }
  Rs.Te = {
    ue: function (r) {
      if (typeof r["cart"] !== "object") {
        return Rs.p.br
      }
      if (
        typeof r["cart"]["count"] === "undefined" ||
        r["cart"]["count"] === "" ||
        isNaN(r["cart"]["count"])
      ) {
        return Rs.p.gr
      }
      return true
    },
  }
  Rs.Ie = function (r) {
    this.Le =
      "a:not([disabled]), " +
      "button:not([disabled]), " +
      "textarea:not([disabled]), " +
      'input[type="text"]:not([disabled]), ' +
      'input[type="radio"]:not([disabled]), ' +
      'input[type="checkbox"]:not([disabled]), ' +
      "select:not([disabled]), " +
      'span[role="button"], ' +
      'a[tabindex="0"]'
    var n = this,
      i = r,
      e = i.querySelector(".rsModalOverlay"),
      t = i.querySelectorAll(".rsModalCloseButton"),
      s = null,
      a = i.querySelectorAll(this.Le),
      o = new Rs.wr()
    this.open = function () {
      var e = this
      window.addEventListener("beforeunload", function (r) {
        e.close()
      })
      s = document.activeElement
      o.Hr(i)
      if (a.length > 1) {
        a[1].focus()
      } else if (a.length === 1) {
        a[0].focus()
      }
    }
    this.close = function () {
      o.Wr(i)
      i.dispatchEvent(Rs.Events.createEvent(Rs.Events.UPDATE_MODAL_STATE_CLOSE))
      if (s) {
        s.focus()
      }
    }
    this.kr = function (r) {
      if (r.key === "Enter" || r.key === "Escape") {
        n.close()
      }
    }
    this.De = function (r) {
      if (r.key === "Escape") {
        n.close()
        return
      }
      var e = 9,
        t = a[0],
        i = a[a.length - 1]
      if (r.key === "Tab" || r.keyCode === e) {
        if (r.shiftKey) {
          if (document.activeElement === t) {
            i.focus()
            r.preventDefault()
          }
        } else {
          if (document.activeElement === i) {
            t.focus()
            r.preventDefault()
          }
        }
      }
    }
    this.Vr = function (r) {
      if (r.key === " ") {
        n.close()
      }
    }
    this.fe = function () {
      return i
    }
    this.pe = function (r, e) {
      e = e || {}
      var t = document.createElement(r)
      for (var i in e) {
        if (e.hasOwnProperty(i)) {
          t[i] = e[i]
        }
      }
      return t
    }
    this.ce = function (r) {
      try {
        i.querySelector(".rsModalBody").append(r)
      } catch (r) {
        return false
      }
      return true
    }
    this.le = function () {
      var r = 0,
        e = i.getElementsByClassName("rsModalError"),
        t = i.getElementsByTagName("input")
      if (e.length > 0) {
        for (r = 0; r < e.length; r++) {
          e[r].remove()
        }
      }
      if (t.length > 0) {
        for (r = 0; r < t.length; r++) {
          t[r].removeAttribute("aria-describedby")
          t[r].removeAttribute("aria-invalid")
          t[r].value = ""
        }
      }
    }
    this.Ne = function () {
      a = i.querySelectorAll(this.Le)
    }
    if (e !== null) {
      e.addEventListener("click", this.close)
    }
    for (var l = 0; l < t.length; l++) {
      t[l].addEventListener("click", this.close)
      t[l].addEventListener("keydown", this.kr)
      t[l].addEventListener("keyup", this.Vr)
    }
    i.addEventListener("keydown", this.De)
  }
  Rs.ye = function (r, e) {
    this.element = r
    this.options = {
      Me: true,
      loop: false,
      be: false,
      ge: true,
      Ue: '<svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
      we: 20,
      Fe: false,
      preload: [0, 1],
      Be: true,
      spacing: 4,
    }
    if (e) {
      for (var t in e) {
        this.options[t] = e[t]
      }
    }
    this.init = function () {
      var r = this
      if (!r.isSupported) {
        return
      }
      r.He = r.element.querySelector(".rsCarouselScroller")
      r.We = r.element.querySelector(".rsCarouselContainer")
      r.items = r.He.children
      r.ke = r.ke.bind(r)
      r.xe = r.xe.bind(r)
      r.Ve = r.Ve.bind(r)
      r.Ge = r.Ge.bind(r)
      r.Ye = r.Ye.bind(r)
      r.ze = r.ze.bind(r)
      if (r.options.ge) {
        r.Ze = r.je("prev", "Previous", r.ke)
        r.Qe = r.je("next", "Next", r.xe)
      }
      r.Ke = document.createElement("div")
      r.Ke.className = "rsCarouselControlsContainer"
      r.element.appendChild(r.Ke)
      r.ze()
      addPassiveEventListener(r.He, "touchstart", r.Ye)
      addPassiveEventListener(r.He, "wheel", r.Ge)
      addPassiveEventListener(r.He, "scroll", r.Ve)
      addPassiveEventListener(window, "resize", r.ze)
    }
    this.je = function (r, e, t, i) {
      var n = this
      var s = document.createElement("button")
      var a = document.createElement("span")
      a.setAttribute("aria-hidden", "true")
      a.innerHTML = n.options.Ue
      s.className = "rsCarouselArrow rsCarouselArrow--" + r
      s.appendChild(a)
      s.title = e
      s.setAttribute("type", "button")
      s.setAttribute("aria-label", e)
      s.onclick = t
      if (!i) {
        i = n.element
      }
      i.appendChild(s)
      return s
    }
    this.isSupported = function () {
      var r = document.createElement("div").style
      var e = "perspective" in r && "transform" in r
      if (window.requestAnimationFrame && Date.now && e) {
        return true
      }
    }
    this.Ve = function () {
      var r = this
      r.qe = r.Xe()
      if (r.Je === "button-click") {
        r.$e()
        if (r.rt) {
          clearTimeout(r.rt)
        }
        return
      }
      if (!r.rt) {
        r.$e()
        r.rt = setTimeout(function () {
          r.rt = null
          r.$e()
        }, 200)
      }
    }
    this.$e = function () {
      var r = this
      var e = r.et()
      if (r.options.ge && !r.options.loop) {
        var t = r.tt - r.it
        r.Ze.disabled = e <= 0
        r.Qe.disabled = e >= t - 1
      }
      r.nt()
      r.st()
      r.ot = r.qe
      r.lt = r.ut
    }
    this.dt = function (r) {
      var e = this
      if (r >= 0) {
        var t = e.ft(r)
        e.scrollTo(t, "button-click")
        e.st(r)
      }
    }
    this.ct = function () {
      var r = this
      var e = r.et()
      var t = e / (r._t + r.spacing)
      var i = Math.floor(t)
      return r.items[i]
    }
    this.nt = function () {
      var r = this
      var e = r.et()
      var t = Math.round(e / (r._t + r.spacing))
      var i
      var n = Math.floor(t)
      var s = t + (r.vt - 1)
      var a
      for (i = n; i < s; i++) {
        r.Rt(i)
        a = r.items[i]
        if (a) {
          a.dataset["active"] = "1"
        }
      }
      var o = r.options.preload[1]
      if (o > 0) {
        for (i = n + r.vt; i < s + r.vt * o; i++) {
          r.Rt(i)
        }
      }
      for (i = n + r.vt; i < r.It; i++) {
        a = r.items[i]
        if (a) {
          a.dataset["active"] = "0"
        }
      }
      var l = r.options.preload[0]
      if (l > 0) {
        for (i = n - r.vt * l; i < n; i++) {
          r.Rt(i)
          a = r.items[i]
          if (a) {
            a.dataset["active"] = "0"
          }
        }
      }
    }
    this.Rt = function (r) {
      var e = this
      if (e.options.loop) {
        if (r > e.It - 1) {
          r = r - e.It
        }
        if (r < 0) {
          r = e.It + r
        }
      }
      var t = e.items[r]
      if (!t) {
        return
      }
      if (t.dataset["loadInitiated"]) {
        return
      }
      t.dataset["loadInitiated"] = true
      var i = t.querySelector("img")
      if (!i || !i.dataset["src"]) {
        return
      }
      i.src = i.dataset["src"]
      if (i.dataset["srcset"]) {
        i.srcset = i.dataset["srcset"]
      }
      if (i.decode) {
        i.decode()
          .then(s)
          .catch(function () {})
      } else {
        i.onload = s
      }
      var n = Math.random()
      function s() {
        i.dataset["src"] = null
        i.removeAttribute("data-src")
      }
    }
    this.Ge = function () {
      this.Je = "wheel"
    }
    this.Ye = function () {
      this.Je = "touch"
    }
    this.Ot = function () {
      var r = this
      removePassiveEventListener(r.He, "touchstart", r.Ye)
      removePassiveEventListener(r.He, "wheel", r.Ge)
      removePassiveEventListener(r.He, "scroll", r.Ve)
      removePassiveEventListener(window, "resize", r.ze)
    }
    this.et = function () {
      var r = this
      if (r.Je === "button-click" || r.Je === "autoplay") {
        return r.St
      } else {
        return r.He.scrollLeft
      }
    }
    this.Xe = function () {
      var r = this
      var e = r.et()
      var t = e / (r.He.offsetWidth + r.spacing)
      t = Math.round(t)
      var i = r.tt - r.it
      if (e >= i - 1) {
        t = r.ut - 1
      } else if (e <= 1) {
        t = 0
      }
      return t
    }
    this.ft = function (r, e) {
      var t = this,
        i = this.Et(),
        n = this.options.Tt[i]
      r = t.ht(r)
      var s = r * (t.He.offsetWidth + t.spacing - (n / 100) * t._t)
      return s
    }
    this.scrollTo = function (r, e) {
      var t = this
      t.Je = e || "button-click"
      t.St = r
      if (!t.options.Be) {
        t.He.scrollLeft = r
        return
      }
      if (supportsSmoothScroll) {
        t.He.scrollTo({ left: r, behavior: "smooth" })
      } else {
        t.At(r)
      }
    }
    this.ht = function (r) {
      var e = this
      if (r > e.ut - 1) {
        if (e.options.loop || loop) {
          r = 0
        } else {
          r = e.ut - 1
        }
      } else if (r < 0) {
        if (e.options.loop || loop) {
          r = e.ut - 1
        } else {
          r = 0
        }
      }
      return r
    }
    this.st = function (r) {
      var e = this
      r = e.ht(r)
      var t = Math.round(e.et() / (e.items[0].offsetWidth + e.spacing)),
        i = t,
        n = t + (e.vt - 1),
        s = r,
        a = e.ut - 1,
        o = e.It % e.vt
      if (o > 0 && a === s && e.vt > o) {
        i -= e.vt - o
      }
      for (var l = 0; l < e.It; l++) {
        var u = 0
        var d = e.items[l].querySelectorAll("a, button")
        if (l >= i && l <= n) {
          e.items[l].removeAttribute("aria-hidden")
          e.items[l].removeAttribute("tabindex")
          for (u = 0; u < d.length; u++) {
            d[u].removeAttribute("tabindex")
          }
        } else {
          e.items[l].setAttribute("aria-hidden", "true")
          e.items[l].setAttribute("tabindex", "-1")
          for (u = 0; u < d.length; u++) {
            d[u].setAttribute("tabindex", "-1")
          }
        }
      }
    }
    this.next = function () {
      var r = this
      var e = r.ft(r.qe + 1)
      r.scrollTo(e, "button-click")
      r.st(r.qe + 1)
    }
    this.Nt = function () {
      var r = this,
        e = r.ft(r.qe - 1)
      r.scrollTo(e, "button-click")
      r.st(r.qe - 1)
    }
    this.xe = function () {
      this.next()
    }
    this.ke = function () {
      this.Nt()
    }
    this.Ct = function (r) {
      var e = this
      e.He.innerHTML = r
      e.items = e.He.children
      e.Pt = null
      e.ze()
    }
    this.ze = function (r) {
      var e = this
      e.spacing = parseResponsiveOption(e.options.spacing) || 0
      e.vt = Math.floor(e.We.offsetWidth / (e.items[0].offsetWidth + e.spacing))
      e.Lt = e.element.getBoundingClientRect()
      e.Dt = { left: 0, right: document.body.clientWidth }
      if (e.options.be) {
        if (typeof e.options.be === "string") {
          e.yt = window.matchMedia(e.options.be).matches
        } else {
          e.yt = Boolean(e.options.be)
        }
      } else {
        e.yt = false
      }
      if (e.yt) {
        e.Mt = { left: e.Dt.left, right: e.Dt.right }
      } else {
        e.Mt = { left: e.Lt.left, right: e.Lt.right }
      }
      e.it = e.Mt.right - e.Mt.left
      e.bt = e.Lt.right - e.Lt.left
      e.startOffset = Math.round(e.Lt.left - e.Mt.left)
      e.endOffset = Math.round(e.Mt.right - e.Lt.right)
      e.We.style.width = e.it - e.options.we * 2 + "px"
      e.We.style.marginLeft =
        Math.floor(e.Mt.left - e.Lt.left) + e.options.we + "px"
      e.It = 0
      e.gt = 0
      e._t = Math.round((e.Lt.width / e.vt) * 100) / 100
      if (e.spacing > 0 && e.vt > 1) {
        e._t -= Math.round(((e.spacing * (e.vt - 1)) / e.vt) * 100) / 100
      }
      var t = e.He.children
      var i
      if (!e.Ut) {
        e.Ut = e.startOffset || e.endOffset || e.yt
      }
      for (var n = 0; n < t.length; n++) {
        if (!t[n] || t[n] === e.Pt) {
          continue
        }
        i = t[n]
        if (e.Ut) {
          i.style.width = e._t + "px"
        }
        if (e.options.Me) {
          i.style.wt = "start"
          i.style.scrollSnapAlign = "start"
        }
        e.gt += e._t + e.spacing
        e.It++
      }
      i.style.marginRight = 0
      e.gt -= e.spacing
      e.tt = e.startOffset + e.gt + e.endOffset
      t[0].style.marginLeft = e.startOffset + "px"
      if (e.options.Me) {
        e.Ft(true)
      }
      if (e.endOffset > 0 || e.Pt) {
        if (!e.Pt) {
          e.Pt = document.createElement("div")
          e.Pt.className = "rsCarouselSpacer"
          e.Pt.style.visibility = "hidden"
          e.Pt.style.flex = "none"
          e.He.appendChild(e.Pt)
        }
        e.Pt.style.width = e.endOffset + "px"
      }
      e.Bt = Math.floor(e.tt) <= Math.floor(e.it)
      e.element.classList[e.Bt ? "add" : "remove"]("rsCarouselNavDisabled")
      e.Je = "resize"
      e.ut = Math.ceil(e.gt / (e.bt + e.spacing))
      e.qe = e.Xe()
      if (e.options.Me && e.yt) {
        e.He.style.scrollPaddingLeft = e.startOffset + "px"
      }
      if (r) {
        var s = e.ft(e.qe)
        e.He.scrollLeft = s
      }
      e.Ht = t[0].getBoundingClientRect().height
      e.$e()
      if (e.options.ge && e.options.Fe) {
        if (e.Ht > 50) {
          var a = Math.round(e.Ht / 2) + "px"
          e.Ze.style.top = a
          e.Qe.style.top = a
        }
      }
    }
    this.Ft = function (r) {
      var e = this
      e.He.style.Wt = r ? "mandatory" : "none"
      e.He.style.scrollSnapType = r ? "x mandatory" : "none"
    }
    this.At = function (r) {
      var e = this
      if (e.options.Me) {
        e.Ft(false)
      }
      var t = r > e.He.scrollLeft
      var i
      if (e.kt) {
        i = t !== e.xt ? sineEaseInOut : sineEaseOut
        cancelAnimationFrame(e.kt)
      } else {
        i = sineEaseInOut
      }
      e.xt = t
      var n = new Date().getTime()
      var s = e.He.scrollLeft
      var a
      var o = r
      var l = 300
      e.kt = requestAnimationFrame(u)
      function u() {
        a = new Date().getTime() - n
        if (a >= l) {
          e.kt = false
          e.He.scrollLeft = o
          return
        }
        e.He.scrollLeft = (o - s) * i(a / l) + s
        e.kt = requestAnimationFrame(u)
      }
    }
    this.Et = function () {
      var r = ["xl", "lg", "md", "sm", "xs"],
        e = []
      for (var t = 0; t < r.length; t++) {
        e[r[t]] = window
          .getComputedStyle(this.element)
          .getPropertyValue("--breakpoint-" + r[t])
      }
      for (var i = 0; i < r.length; i++) {
        if (window.matchMedia("(min-width: " + e[r[i]] + ")").matches) {
          return r[i]
        }
      }
      return null
    }
    this.Vt = function (r) {
      if (!this.element) {
        return
      }
      var e = this.Et()
      if (!e) {
        return
      }
      var t = this.options.Tt[e],
        i = this.element.offsetWidth,
        n = Math.floor(i / (this.items[0].offsetWidth + this.spacing)),
        s = (t / 100) * i,
        a = (i - s) / n,
        o = this.element.querySelectorAll(r)
      o.forEach(function (r, e) {
        r.style.minWidth = a
      })
      this.ze()
    }
  }
  const BOOTSTRAP_BREAKPOINTS = { Gt: 1200, Yt: 992, zt: 768, Zt: 576, jt: 0 }
  var supportsSmoothScroll =
    "scrollBehavior" in document.documentElement.style &&
    "scrollTo" in document.documentElement
  var supportsPassiveEvents = false
  try {
    var opts = Object.defineProperty({}, "passive", {
      get: function () {
        supportsPassiveEvents = true
      },
    })
    window.addEventListener("test", null, opts)
  } catch (r) {}
  function sineEaseInOut(r) {
    return -(Math.cos(Math.PI * r) - 1) / 2
  }
  function sineEaseOut(r) {
    return Math.sin(r * (Math.PI / 2))
  }
  function triggerEvent(r, e, t) {
    var i
    if (typeof window.CustomEvent === "function") {
      i = new CustomEvent(e, t)
    } else {
      i = document.createEvent("CustomEvent")
      i.initCustomEvent(e, true, true, t)
    }
    r.dispatchEvent(i)
  }
  function addPassiveEventListener(r, e, t) {
    r.addEventListener(e, t, supportsPassiveEvents ? { passive: true } : false)
  }
  function removePassiveEventListener(r, e, t) {
    r.removeEventListener(
      e,
      t,
      supportsPassiveEvents ? { passive: true } : false
    )
  }
  function parseResponsiveOption(r) {
    if (!r) {
      return 0
    }
    if (typeof r === "number") {
      return r
    }
    var e
    for (var t in BOOTSTRAP_BREAKPOINTS) {
      if (r[t]) {
        e = r[t]
        var i = "(min-width: " + BOOTSTRAP_BREAKPOINTS[t] + "px)"
        if (window.matchMedia(i).matches) {
          return r[t]
        }
      }
    }
    if (e) {
      return e
    }
  }
  Rs.Qr = {
    Qt: 0,
    send: function (r, e) {
      var t = new XMLHttpRequest(),
        i = new Date(),
        n = new FormData(),
        s = "",
        a = Rs.Kr.Xr()
      if (this.Qt === 20) {
        console.log("RS API error code: " + r + " | " + a)
        return
      }
      n.append("errorCode", r)
      n.append("uri", window.location.href)
      n.append("pvid", a)
      n.append("browserDate", i.toISOString())
      if (e) {
        Object.keys(e).forEach(function (r) {
          if (e[r] instanceof Error) {
            e[r] = JSON.stringify(e[r], Object.getOwnPropertyNames(e[r]))
          }
        })
        s = JSON.stringify(e)
      }
      n.append("additionalData", s)
      t.open("POST", "https://shop.skbcases.com/rs/api/clientSideErrorReceiver")
      t.withCredentials = true
      t.send(n)
      this.Qt++
    },
  }
  Rs.Kt = function (r) {
    var o = r
    this.qt = function (r, e, t) {
      var i = e ? r.querySelectorAll(e) : [r]
      if (i.length === 0) {
        return
      }
      var n = Object.keys(o)
      n.sort(function (r, e) {
        if (r.length < e.length) {
          return 1
        }
        if (r.length > e.length) {
          return -1
        }
        return 0
      })
      n.forEach(function (r) {
        while (t.includes(r)) {
          t = t.replace(r, o[r])
        }
      })
      if (t.indexOf("RS_") !== -1) {
        var s = {}
        s["rootElement"] = r.outerHTML
        s["parentContainerSelector"] = e
        s["htmlStyleC"] = t
        s["map"] = o
        Rs.Qr.send(Rs.p.h, s)
        return
      }
      for (var a = 0; a < i.length; a++) {
        i[a].outerHTML = t
      }
    }
    this.Xt = function (r, e) {
      var t = r.classList
      return e.filter(function (r) {
        return t.contains(r)
      })
    }
    this.Jt = function (e, r) {
      var t = ""
      r.forEach(function (r) {
        if (e.hasAttribute(r)) {
          t += r + '="' + e.getAttribute(r) + '" '
        }
      })
      return t
    }
    this.$t = function (r) {
      return ((r || "id") + Math.random()).replace(".", "-")
    }
  }
  Rs.ri = function (r) {
    var o = r
    this.ei = function () {
      var i =
        "<span class='rsWebcodeWrapper rsHidden' aria-hidden='true'>" +
        "RS_SESSION_WEBCODE_LABEL <span class='rsWebcode'></span>" +
        "</span>"
      o.qt(document, ".rsWebcodeContainer", i)
      i =
        "<span class='rsPhoneWrapper rsHidden' aria-hidden='true'>" +
        "RS_SESSION_PHONE_LABEL <span class='rsPhone'></span>" +
        "</span>"
      o.qt(document, ".rsPhoneContainer", i)
      i =
        "<span class='rsUserAccountLinkWrapper rsHidden' aria-hidden='true' " +
        "data-rs-user-logged-in-label='RS_SESSION_USER_LOGGED_IN_LINK_LABEL' " +
        "data-rs-user-not-logged-in-label='RS_SESSION_USER_NOT_LOGGED_IN_LINK_LABEL'>" +
        "<a class='rsUserAccountLink rsUserIcon' aria-label='User Account' target='_parent'></a>" +
        "</span>" +
        "<span class='rsUserAccountLogoutLinkWrapper rsHidden' aria-hidden='true' " +
        "data-rs-log-out-label='RS_SESSION_USER_LOG_OUT_LINK_LABEL'>" +
        "<a class='rsUserAccountLogoutLink' aria-label='RS_SESSION_USER_LOG_OUT_LINK_LABEL' target='_parent'></a>" +
        "</span>"
      o.qt(document, ".rsUserAccountLinkContainer", i)
      var r = document.querySelector(".rsCookieConsent"),
        e = "",
        t = ""
      if (r && r.classList.contains("rsCartLinkAndItemCountContainer")) {
        e = "rsCookieConsent"
        t = o.Jt(r, [Rs.Jr.re])
      }
      i =
        "<span class='rsCartLinkAndItemCountWrapper rsHidden " +
        e +
        "'" +
        " aria-hidden='true' aria-label='Cart Quantity' " +
        t +
        ">" +
        "<a class='rsCartLink rsCartCount rsCartIcon' target='_parent'></a>" +
        "</span>"
      o.qt(document, ".rsCartLinkAndItemCountContainer", i)
      i =
        "<span class='rsZipCodeWrapper rsHidden' aria-hidden='true' aria-label='Zip Code' >" +
        "<span class='rsShippingLocationIcon'>RS_SESSION_ZIP_CODE_LABEL</span> <span class='rsZipCode' role='button' tabindex='0' aria-label='Change your shipping zipcode'></span>" +
        "</span>"
      o.qt(document, ".rsZipCodeContainer", i)
      var n = o.$t("rsZipCodeModal")
      var s = n + "-submit"
      i =
        "<div class='rsModalWrapper rsZipCodeModalWrapper rsHidden' aria-hidden='true'>" +
        "<div class='rsModalOverlay'></div>" +
        "<div class='rsModal' role='dialog' aria-labelledby='" +
        n +
        "'>" +
        "<div class='rsModalHeader'>" +
        "<span class='rsModalTitle' id='" +
        n +
        "'>RS_SESSION_ZIP_SUBMISSION_INSTRUCTION_LABEL</span>" +
        "<span class='rsModalCloseButton rsModalCloseX' role='button' aria-label='Close' tabindex='0'>&times;</span>" +
        "</div>" +
        "<div class='rsModalBody'>" +
        "<form class='rsZipCodeModalForm'>" +
        "<input class='rsZipCodeModalInput' aria-labelledby='" +
        s +
        "' name='zip' type='text' placeholder='RS_SESSION_ZIP_SUBMISSION_PLACEHOLDER_LABEL' autocomplete='postal-code'>" +
        "<button type='submit' id='" +
        s +
        "' class='rsZipCodeModalSubmit'>RS_SESSION_ZIP_SUBMISSION_SUBMIT_LABEL</button>" +
        "</form>" +
        "</div>" +
        "</div>" +
        "</div>"
      o.qt(document, ".rsZipCodeModalContainer", i)
      var a = o.$t("rsContinueShoppingModal")
      i =
        '<div class="rsModalWrapper rsContinueShoppingModalWrapper rsHidden">' +
        '<div class="rsModalOverlay"></div>' +
        '<div class="rsModal" role="dialog" aria-labelledby="' +
        a +
        '">' +
        '<div class="rsModalSubheader">' +
        '<span class="rsItemAddedToCartText rsModalTitle" id="' +
        a +
        '">RS_SESSION_ITEM_ADDED_TO_CART_TEXT</span>' +
        '<span class="rsModalCloseButton rsModalCloseX" role="button" aria-label="Close" tabindex="0">&times;</span>' +
        "</div>" +
        '<div class="rsModalBody">' +
        '<a class="rsViewCartButton rsModalButton" role="button" tabindex="0">RS_SESSION_VIEW_CART_BUTTON_LABEL</a>' +
        '<a class="rsViewCartButton rsModalButton rsModalCloseButton" role="button" tabindex="0">RS_SESSION_CONTINUE_SHOPPING_BUTTON_LABEL</a>' +
        "</div>" +
        "</div>" +
        "</div>"
      o.qt(document, ".rsContinueShoppingModalContainer", i)
      document
        .querySelectorAll(".rsMiniCartModalContainer")
        .forEach(function (r) {
          var e = o.$t("rsMiniCartModalTitle"),
            t = o.Jt(r, ["data-rs-item-list-name", "data-rs-item-list-id"])
          i =
            '<div class="rsModalWrapper rsMiniCartModalWrapper rsHidden">' +
            '<div class="rsModalOverlay"></div>' +
            '<div class="rsModal" role="dialog" aria-labelledby="' +
            e +
            '">' +
            '<div class="rsModalSubheader">' +
            '<span class="rsCheckIcon"></span>' +
            '<span class="rsItemAddedToCartText rsModalTitle" id="' +
            e +
            '">RS_SESSION_MINI_CART_HEADER_ITEM_ADDED</span>' +
            '<span class="rsModalCloseButton rsModalCloseX" role="button" aria-label="Close" tabindex="0">&times;</span>' +
            "</div>" +
            '<div class="rsModalBody">' +
            '<div class="rsMiniCartContainer">' +
            '<div class="rsProductInfoContainer">' +
            '<div class="rsProductImageWrapper">' +
            '<img class="rsProductImage" src=""/>' +
            "</div>" +
            '<div class="rsProductInfo">' +
            '<div class="rsProductTitle"></div>' +
            '<div class="rsProductInfoFooter">' +
            "<label>" +
            '<span class="rsItemQtySelectLabelText">RS_PRODUCT_ITEM_QTY_SELECT_LABEL</span>' +
            '<select class="rsItemQtySelect" name="quantity">' +
            '<option value="1" selected>1</option>' +
            '<option value="2">2</option>' +
            '<option value="3">3</option>' +
            '<option value="4">4</option>' +
            '<option value="5">5</option>' +
            '<option value="6">6</option>' +
            '<option value="7">7</option>' +
            '<option value="8">8</option>' +
            '<option value="9">9</option>' +
            '<option value="10">10</option>' +
            "</select>" +
            "</label>" +
            '<div class="rsPriceWrapper">' +
            'RS_PRODUCT_PRICE_LABEL <span class="rsPrice"></span>' +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>" +
            '<div class="rsMiniCartSummaryContainer">' +
            '<div class="rsMiniCartSummary">' +
            '<span class="rsCartIcon"> Subtotal</span>' +
            '<span><span class="rsCartCount"></span>|<span class="rsCartSubtotal"></span></span>' +
            "</div>" +
            '<a class="rsModalButton rsModalCloseButton" role="button" tabindex="0">RS_SESSION_CONTINUE_SHOPPING_BUTTON_LABEL</a>' +
            '<a class="rsViewCartButton rsModalButton" role="button">RS_SESSION_VIEW_CART_BUTTON_LABEL</a>' +
            "</div>" +
            "</div>" +
            '<div class="rsRelatedItemsContainer" role="region" aria-label="RS_SESSION_MINI_CART_CAROUSEL_ARIA_LABEL">' +
            '<div class="rsCarouselContainer">' +
            '<div class="rsCarouselScroller">' +
            '<div class="rsRiCarouselCard" role="group" aria-label="">' +
            '<div class="rsRiCarouselCardContainer">' +
            '<div class="rsRiThumbnailContainer">' +
            '<div class="rsRiThumbnailWrapper">' +
            '<img class="rsRiThumbnailImg" src="" aria-labelledby=""/>' +
            "</div>" +
            '<span class="rsRiThumbnailBadge"></span>' +
            "</div>" +
            '<div class="rsRiProductInfoContainer">' +
            '<div class="rsRiTitleLinkContainer">' +
            '<a class="rsRiTitleLink" href="" id=""></a>' +
            "</div>" +
            '<div class="rsRiPriceContainer">' +
            '<span class="rsRiPrice"></span>' +
            '<button class="rsRiAddToCartButton" ' +
            'data-rs-carousel-added-label="RS_SESSION_MINI_CART_CAROUSEL_ADDED_LABEL" ' +
            'data-rs-item-id="" ' +
            'data-rs-item-url="" ' +
            'data-rs-item-list-index="" ' +
            t +
            ">" +
            "RS_PRODUCT_ADD_TO_CART_SUBMIT_BUTTON_LABEL" +
            "</button>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>" +
            "</div>"
          o.qt(r, null, i)
        })
    }
  }
  Rs.ti = function (r) {
    var n = r,
      i = "https://shop.skbcases.com"
    var s = function (r, e, t) {
      var i = document.querySelectorAll(r)
      if (i.length === 0) {
        return
      }
      for (var n = 0; n < i.length; n++) {
        t(i[n], e)
      }
    }
    var a = function (r) {
      if (r) {
        return i + "/account-info"
      }
      return (
        i +
        "/account-login?" +
        encodeURI("uaRedirectUrl=" + window.location.href)
      )
    }
    this.ii = function (r, e = false) {
      s(".rsWebcodeWrapper:not(.rsVisible)", r, function (r, e) {
        n.Yr(r, ".rsWebcode", e["webcode"])
        n.Hr(r)
      })
      s(".rsPhoneWrapper:not(.rsVisible)", r, function (r, e) {
        n.Yr(r, ".rsPhone", e["phone"])
        n.Hr(r)
      })
      if (r["user"]["enabled"]) {
        s(".rsUserAccountLinkWrapper:not(.rsVisible)", r, function (e, t) {
          var r = e.getAttribute("data-rs-user-logged-in-label"),
            i = e.getAttribute("data-rs-user-not-logged-in-label")
          if (t["user"]["isLoggedIn"]) {
            e.setAttribute("data-rs-user-id", t["user"]["id"])
          }
          n.Yr(
            e,
            ".rsUserAccountLink",
            t["user"]["isLoggedIn"]
              ? r.replace("{rs_user_name}", t["user"]["firstName"])
              : i,
            function (r) {
              r.setAttribute("href", a(t["user"]["isLoggedIn"]))
              n.Hr(e)
            }
          )
        })
      }
      s(".rsUserAccountLogoutLinkWrapper:not(.rsVisible)", r, function (e, r) {
        if (!r["user"]["isLoggedIn"]) {
          return
        }
        var t = e.getAttribute("data-rs-log-out-label")
        n.Yr(e, ".rsUserAccountLogoutLink", t, function (r) {
          r.setAttribute("href", i + "/account-logout")
          n.Hr(e)
        })
      })
      var t = function (r, e) {
        n.Yr(r, ".rsCartCount", e["cart"]["count"])
        var t = n.Gr(r, ".rsCartLink")
        if (t) {
          t.setAttribute("href", n.zr())
        }
        n.Hr(r)
      }
      s(".rsCartLinkAndItemCountWrapper:not(.rsVisible)", r, t)
      s(".rsZipCodeWrapper:not(.rsVisible)", r, function (r, e) {
        var t = Rs.ae._e(e["location"]["zip"], e["location"]["city"])
        n.Yr(r, ".rsZipCode", t)
        n.Hr(r)
      })
      s(".rsCartAddWrapper:not(.rsVisible)", r, function (r) {
        n.Hr(r)
      })
      s(".rsContinueShoppingModalWrapper", r, o)
      s(".rsMiniCartModalWrapper", r, o)
      if (e) {
        s(".rsCartLinkAndItemCountWrapper", r, t)
      }
    }
    let o = function (r) {
      let e = n.Gr(r, ".rsViewCartButton")
      if (e) {
        e.setAttribute("href", n.zr() + "?cssl")
      }
    }
  }
  Rs.ni = function () {
    var t = false,
      r = new Rs.ri(
        new Rs.Kt(Rs["ReplacementText"]["placeholderToReplacementTextMap"])
      ),
      i = new Rs.ti(new Rs.wr())
    this.si = function (e = false) {
      if (t) {
        return
      }
      t = true
      r.ei()
      Rs.Kr.qr(
        "/rs/api/" + Rs.i + "/sessions",
        "GET",
        {},
        Rs.ai.ue,
        function (r) {
          i.ii(r, e)
          Rs.ae.ve(r["location"]["zip"])
          Rs.ae.Re(i)
          Rs.ae.Oe()
          if (r["cookieConsent"]["enabled"]) {
            Rs.Jr.init(
              r["cookieConsent"],
              document.querySelector(".rsCookieConsent")
            )
          }
          t = false
        }
      )
    }
  }
  Rs.ai = {
    ue: function (r) {
      if (typeof r !== "object") {
        return Rs.p._r
      }
      if (typeof r["cart"] !== "object") {
        return Rs.p.vr
      }
      if (
        typeof r["cart"]["count"] === "undefined" ||
        r["cart"]["count"] === "" ||
        isNaN(r["cart"]["count"])
      ) {
        return Rs.p.Rr
      }
      if (typeof r["location"] !== "object") {
        return Rs.p.Ar
      }
      if (
        typeof r["location"]["zip"] === "undefined" ||
        (r["location"]["zip"] !== null &&
          typeof r["location"]["zip"] !== "string")
      ) {
        return Rs.p.Cr
      }
      if (
        typeof r["location"]["city"] === "undefined" ||
        (r["location"]["city"] !== null &&
          typeof r["location"]["city"] !== "string")
      ) {
        return Rs.p.mr
      }
      if (typeof r["phone"] === "undefined" || r["phone"] === "") {
        return Rs.p.Ir
      }
      if (typeof r["user"] !== "object") {
        return Rs.p.Or
      }
      if (typeof r["user"]["enabled"] !== "boolean") {
        return Rs.p.hr
      }
      if (r["user"]["enabled"]) {
        if (typeof r["user"]["isLoggedIn"] !== "boolean") {
          return Rs.p.Sr
        }
        if (r["user"]["isLoggedIn"]) {
          if (
            typeof r["user"]["firstName"] === "undefined" ||
            r["user"]["firstName"] === ""
          ) {
            return Rs.p.Er
          }
        }
      }
      if (typeof r["cookieConsent"]["enabled"] !== "boolean") {
        return Rs.p.Pr
      }
      if (typeof r["webcode"] === "undefined" || r["webcode"] === "") {
        return Rs.p.Tr
      }
      return true
    },
  }
  Rs.t(function () {
    try {
      var e = new Rs.ni()
      document.addEventListener(
        Rs.Events.POPULATE_SESSION_ELEMENTS,
        function () {
          e.si()
        }
      )
      document.dispatchEvent(
        Rs.Events.createEvent(Rs.Events.POPULATE_SESSION_ELEMENTS)
      )
      window.addEventListener("pageshow", function (r) {
        if (
          r.persisted ||
          (typeof window.performance != "undefined" &&
            window.performance.navigation.type === 2)
        ) {
          e.si(true)
        }
      })
      Rs.o.l(".rsSessionElement", Rs.Events.POPULATE_SESSION_ELEMENTS)
    } catch (r) {
      var t = {}
      t["source"] = "sessionController"
      t["caughtError"] = r
      t["fullHtmlDump"] = document.documentElement.outerHTML
      Rs.Qr.send(Rs.p._, t)
    }
  })
  Rs.manuallyPopulateSessionElements = function () {
    Rs.t(function () {
      try {
        var e = new Rs.ni()
        document.addEventListener(
          Rs.Events.POPULATE_SESSION_ELEMENTS,
          function () {
            e.si()
          }
        )
        document.dispatchEvent(
          Rs.Events.createEvent(Rs.Events.POPULATE_SESSION_ELEMENTS)
        )
        window.addEventListener("pageshow", function (r) {
          if (
            r.persisted ||
            (typeof window.performance != "undefined" &&
              window.performance.navigation.type === 2)
          ) {
            e.si(true)
          }
        })
        Rs.o.l(".rsSessionElement", Rs.Events.POPULATE_SESSION_ELEMENTS)
      } catch (r) {
        var t = {}
        t["source"] = "sessionController"
        t["caughtError"] = r
        t["fullHtmlDump"] = document.documentElement.outerHTML
        Rs.Qr.send(Rs.p._, t)
      }
    })
  }
  Rs.oi = function (r) {
    var i = r,
      a = null,
      c = new Rs.Kt()
    this.li = function (r, e, t, i) {
      var n = t.querySelector(".rsCarouselScroller")
      o(e, n)
      if (a === null) {
        var s = {
          Me: true,
          vt: { Gt: 3, Yt: 3, zt: 2, Zt: 1, jt: 1 },
          spacing: { Gt: 20, Yt: 20, zt: 15, Zt: 20, jt: 20 },
          Tt: { Gt: 20, Yt: 20, zt: 14, Zt: 15, jt: 15 },
        }
        s.Ue = i.di
          ? i.di
          : '<svg aria-hidden="true" focusable="false" data-icon="angle-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path fill="currentColor" d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>'
        s.we = i.we ? i.we : "20"
        a = new Rs.ye(t, s)
        a.init()
      }
      u(r, t)
    }
    var o = function (r, e) {
      var t = document.querySelector(".rsRiCarouselCard.rsHidden")
      if (!t) {
        var i = e.querySelector(".rsRiCarouselCard")
        t = i.cloneNode(true)
        i.remove()
        if (!t.classList.contains("rsHidden")) {
          t.classList.add("rsHidden")
        }
        document.body.appendChild(t)
      }
      t.style.display = ""
      e.innerHTML = ""
      for (var n = 0; n < r.length; n++) {
        var s = l(r[n], t.cloneNode(true), n + 1)
        s.setAttribute("aria-label", "Card " + (n + 1) + " of " + r.length)
        e.append(s)
      }
    }
    var l = function (r, e, t) {
      var i = c.$t("rsRiTitleLink"),
        n = new Rs.fi(r["coreData"]),
        s = e.querySelector(".rsRiAddToCartButton"),
        a = e.querySelector(".rsRiThumbnailImg"),
        o = e.querySelector(".rsRiThumbnailContainer"),
        l = e.querySelector(".rsRiTitleLink"),
        u = e.querySelector(".rsRiPrice")
      if (a) {
        a.setAttribute("src", r["extraData"]["img"])
        a.setAttribute("aria-labelledby", i)
      }
      if (r["extraData"]["badge"]) {
        var d = document.createElement("span")
        d.classList.add("rsRiThumbnailBadge")
        d.innerHTML = r["extraData"]["badge"]
        o.appendChild(d)
      } else {
        var f = e.querySelector(".rsRiThumbnailBadge")
        if (f) {
          f.remove()
        }
      }
      if (l) {
        l.setAttribute("href", r["extraData"]["url"])
        l.setAttribute("id", i)
        l.innerHTML = r["extraData"]["title"]
      }
      if (u) {
        u.innerHTML = n.ci()
      }
      if (s) {
        s.setAttribute("data-rs-item-id", r["itemId"])
        s.setAttribute("data-rs-item-url", r["extraData"]["url"])
        if (
          s.hasAttribute("data-rs-item-list-name") ||
          s.hasAttribute("data-rs-item-list-id")
        ) {
          s.setAttribute("data-rs-item-list-index", String(t))
        }
      }
      if (e.classList.contains("rsHidden")) {
        e.classList.remove("rsHidden")
      }
      return e
    }
    var u = function (t, r) {
      var e = r.querySelectorAll(".rsRiAddToCartButton")
      e.forEach(function (e, r) {
        e.addEventListener("click", function (r) {
          r.preventDefault()
          if (r.target.disabled !== true) {
            r.target.disabled = true
            i.pi(
              r.target.dataset["rsItemId"],
              r.target.dataset["rsItemUrl"],
              e,
              "rsRiAdded",
              t,
              r.target.dataset["rsItemListIndex"] || 0,
              r.target.dataset["rsItemListName"] || "",
              r.target.dataset["rsItemListId"] || ""
            )
          }
        })
      })
    }
    this.Vt = function () {
      if (!a) {
        return
      }
      a.Vt(".rsCarouselContainer .rsCarouselSlide")
    }
  }
  Rs.Ae = function (r, e) {
    var d = e,
      f = new Rs.wr(),
      c = null,
      p = null,
      s = new Rs._i()
    var _ = function (r, e, t) {
      var i = r.querySelector(".rsItemQtySelect"),
        n = r.querySelector(".rsItemQtySelectLabelText")
      if (!i) {
        return
      }
      i.value = e["qty"]
      if (s.vi(t, e["coreData"])) {
        i.removeEventListener("change", a)
        i.addEventListener("change", a)
        f.Hr(i)
        f.Hr(n)
      } else {
        f.Wr(i)
        f.Wr(n)
      }
    }
    this.Re = function (r, e) {
      var t = e.closest(".rsProductOfferContainer"),
        i = document.querySelector(".rsMiniCartModalWrapper"),
        n = new Rs.fi(r["itemData"]["coreData"]),
        s = e.querySelector('input[name="rsItemUrl"]'),
        a = s.value ? "?rsItemUrl=" + s.value : ""
      p = e
      _(i, r["itemData"], t.querySelector(".rsAddToCartForm"))
      d.Ce(r["cart"])
      d.Pe(".rsCartSubtotal", r["cart"])
      i.querySelector(".rsProductTitle").innerHTML = r["itemData"]["title"]
      i.querySelector(".rsProductImage").src = r["itemData"]["image"]
      i.querySelector(".rsPrice").innerHTML = n.ci()
      i.querySelector(".rsViewCartButton").setAttribute("href", f.zr() + a)
      var o = i.querySelector(".rsRelatedItemsContainer")
      if (
        !!t.getAttribute("data-rs-show-related-items-in-mini-cart") &&
        r["itemData"]["relatedItems"] &&
        r["itemData"]["relatedItems"].length > 0
      ) {
        if (c === null) {
          c = new Rs.oi(this)
          window.addEventListener("resize", function (r) {
            c.Vt()
          })
        }
        var l = {
            di: t.getAttribute("data-rs-carousel-arrow"),
            we: t.getAttribute("data-rs-carousel-arrow-margin"),
          },
          u = t.getAttribute("data-rs-item-id")
        c.li(u, r["itemData"]["relatedItems"], o, l)
        f.Hr(o)
        c.Vt()
      } else {
        f.Wr(o)
      }
    }
    this.me = function () {
      if (c === null) {
        return
      }
      c.Vt()
    }
    this.pi = function (r, e, t, i, n, s, a, o) {
      var l = {
        quantity: 1,
        rsItemId: r,
        rsItemUrl: e,
        rsListIndex: s || 0,
        rsListName: a || "",
        rsListId: o || "",
      }
      if (n !== null) {
        l["rsParentItemId"] = n
      }
      d.addItemsToCart(
        [l],
        function (r, e) {
          let t = e["cartForm"]
          t.classList.add(i)
          t.innerHTML = t.dataset["rsCarouselAddedLabel"]
          d.Pe(".rsCartSubtotal", r["cart"])
          d.Ce(r["cart"])
        },
        null,
        { cartForm: t }
      )
    }
    var a = function (t) {
      t.preventDefault()
      var i = {},
        r = new FormData(p)
      r.forEach(function (r, e) {
        if (e === "quantity") {
          i[e] = t.target.value
        } else {
          i[e] = r
        }
      })
      d.addItemsToCart([i], d.he, null, { cartForm: p, updateQty: true })
    }
  }
  Rs.Ri = function (e, o, t) {
    var n = 25
    var i = 3600
    var s = 10
    var l = {}
    var a = {}
    var u = i && t.jr()
    var d = false
    var r = function () {
      Object.keys(l).forEach(function (r) {
        var e = c(r)
        if (!e) {
          return
        }
        for (var t = 0; t < l[r].length; t++) {
          if (l[r][t].Ii) {
            l[r][t].Ii(e, l[r][t].Oi)
          }
        }
        delete l[r]
      })
    }
    var f = function (r) {
      var e = Rs.ae.oe() || ""
      return "product-offer-" + r + "-" + e + "-" + s
    }
    var c = function (r) {
      var e = t.getItem(f(r))
      if (e && true === o(e)) {
        return e
      }
      return false
    }
    var p = function (r, e) {
      t.setItem(f(r), e, i)
    }
    var _ = function () {
      var r = R()
      if (r.length > 0) {
        e.qr(
          "/rs/api/" + Rs.i + "/products",
          "POST",
          { dcpExternalItemIds: r.join(",") },
          I,
          O,
          S,
          { Si: r }
        )
      }
    }
    var v = function () {
      var i = 0
      Object.keys(l).forEach(function (r) {
        var e = l[r]
        i = e[0].priority
        for (var t = 1; t < e.length; t++) {
          if (e[t].priority < i) {
            i = e[t].priority
          }
        }
        if (!a.hasOwnProperty(i)) {
          a[i] = []
        }
        a[i].push(r)
      })
    }
    var R = function () {
      var r = Object.keys(a).sort(),
        e = [],
        t
      for (var i = 0; i < r.length; i++) {
        t = r[i]
        while (a[t].length > 0 && e.length < n) {
          e.push(a[t].pop())
        }
        if (a[t].length === 0) {
          delete a[t]
        }
        if (e) {
          break
        }
      }
      return e
    }
    var I = function (r) {
      if (typeof r !== "object") {
        return Rs.p.pr
      }
      Object.keys(r).forEach(function (r) {
        if (!l.hasOwnProperty(r)) {
          return Rs.p.pr
        }
      })
      return true
    }
    var O = function (a, r) {
      r.Si.forEach(function (r) {
        var e = a.hasOwnProperty(r) ? a[r] : null,
          t = e ? o(e) : null,
          i = l[r],
          n = 0
        if (typeof i === "undefined") {
          return
        }
        if (!e || t !== true) {
          for (n = 0; n < i.length; n++) {
            if (i[n].Ei) {
              i[n].Ei(i[n].Oi)
            }
          }
          if (e && t !== true) {
            var s = {}
            s["itemId"] = r
            s["parsedResponse"] = e
            Rs.Qr.send(t, s)
          }
          delete l[r]
          return
        }
        for (n = 0; n < i.length; n++) {
          if (i[n].Ii) {
            i[n].Ii(e, i[n].Oi)
          }
        }
        if (u) {
          p(r, e)
        }
        delete l[r]
      })
      _()
    }
    var S = function (r, e) {
      var i = e.httpStatus !== 403
      r.Si.forEach(function (r) {
        var e = l[r]
        if (typeof e === "undefined") {
          return
        }
        for (var t = 0; t < e.length; t++) {
          if (e[t].Ei) {
            e[t].Ei(e[t].Oi, i)
          }
        }
        delete l[r]
      })
      _()
    }
    var E = function (r) {
      if (d) {
        window.setTimeout(function () {
          d = true
          r.flush()
        }, 50)
        d = false
      }
    }
    this.getItem = function (r, e, t, i, n) {
      if (isNaN(n)) {
        n = 1
      }
      if (!l.hasOwnProperty(r)) {
        l[r] = []
      }
      l[r].push({ priority: n, Ii: e, Ei: t, Oi: i })
      if (d) {
        E(this)
      }
    }
    this.flush = function () {
      if (u) {
        r()
      }
      v()
      _()
    }
    this.Ti = function (r) {
      d = r
    }
  }
  Rs.hi = function (n, s) {
    this.getItem = function (r, e, t, i) {
      n.getItem(r, e, t, i, 1)
    }
    this.createEvent = function (r) {
      return Rs.Events.createEvent(r)
    }
    this.addItemsToCart = function (r, e, t, i) {
      if (!Array.isArray(r)) {
        throw new Error("cartItems parameter must be an array.")
      }
      r.forEach(function (r) {
        if (
          typeof r["rsItemId"] !== "string" ||
          typeof r["rsItemUrl"] !== "string" ||
          (typeof r["quantity"] !== "number" &&
            typeof r["quantity"] !== "string") ||
          (typeof r["rsListIndex"] !== "undefined" &&
            typeof r["rsListIndex"] !== "number" &&
            typeof r["rsListIndex"] !== "string") ||
          (typeof r["rsListName"] !== "undefined" &&
            typeof r["rsListName"] !== "number" &&
            typeof r["rsListName"] !== "string") ||
          (typeof r["rsListId"] !== "undefined" &&
            typeof r["rsListId"] !== "number" &&
            typeof r["rsListId"] !== "string") ||
          Object.keys(r).length > 6 + Rs.Ni.Ai * 2
        ) {
          throw new Error(
            "One or more objects within cartItems array have invalid format"
          )
        }
        Rs.Ni.mi(r)
      })
      s.addItemsToCart(r, e, t, i)
    }
  }
  Rs.Ci = function () {
    this.Pi = "out of stock"
    this.Li = "preorder"
    this.Di = "in stock"
    this.yi = "data-rs-notify-me-style"
    this.Mi = "data-rs-notify-me-include-name-fields"
    this.bi = "data-rs-notify-me-name-fields-error"
    this.gi = "accordion"
    var _ = null,
      r = this
    var v = function (r) {
      var e = new FormData(r.target),
        t = e.get("email"),
        i = e.get("phone") || "",
        n = e.get("firstName"),
        s = e.get("lastName"),
        a = e.get("itemStatus"),
        o = e.get("rsItemId"),
        l = e.get("rsItemUrl") || "",
        u = e.get("newsletter") || "0"
      if (!t || !o || !a) {
        return false
      }
      var d = {
        email: t,
        phone: i,
        rsItemId: o,
        rsItemUrl: l,
        itemStatus: a,
        newsletter: u,
      }
      if (n && s) {
        d["firstName"] = n
        d["lastName"] = s
      }
      Rs.Kr.qr(
        "/rs/api/" + Rs.i + "/products/notify-me",
        "POST",
        d,
        function (r) {
          return Array.isArray(r) && !r.length
        }
      )
      return true
    }
    var c = function (r, e, t, i, n, s) {
      if (!_) {
        return
      }
      var a = _.fe().querySelector(".rsNotifyMeModalForm"),
        o = a.querySelector("input[name='itemStatus']"),
        l = a.querySelector("input[name='rsItemId']"),
        u = a.querySelector("input[name='rsItemUrl']")
      o.setAttribute("value", e)
      l.setAttribute("value", t)
      if (u) {
        u.setAttribute("value", i)
      }
      a.addEventListener("submit", function (r) {
        r.preventDefault()
        _.close()
        v(r)
        d(r)
      })
      if (n) {
        O(r, a, s)
      }
      if (Rs["ConfigValues"]["notify_me_sms_enabled"]) {
        r.Hr(a, ".rsNotifyMeModalPhoneFormLabel")
        r.Hr(a, "input[name='phone']")
      }
      if (r.Gr(a, ".rsNotifyMeModalEmailFormLabel")) {
        I(r, e, a)
      } else {
        R(r, e, a)
      }
      _.open()
    }
    var p = function (e, t, r, i, n, s, a, o) {
      if (!_) {
        return
      }
      var l = t.querySelector(".rsNotifyMeFormAccordionWrapper")
      if (!l) {
        return
      }
      if (t && l.querySelector(".rsNotifyMeModalForm") === null) {
        var u = _.fe().querySelector(".rsNotifyMeModalForm").cloneNode(true),
          d = u.querySelector("input[name='itemStatus']"),
          f = u.querySelector("input[name='rsItemId']"),
          c = u.querySelector("input[name='rsItemUrl']")
        l.appendChild(u)
        var p =
          l.getAttribute("data-rs-subscribed-message") ||
          "Subscribed to notifications"
        u.addEventListener("submit", function (r) {
          r.preventDefault()
          e.Wr(l)
          if (v(r)) {
            t.querySelector(".rsNotifyMeOutOfStockLink").textContent = p
            t.querySelector(".rsNotifyMePreorderLink").textContent = p
            t.querySelector(".rsNotifyMeInStockLink").textContent = p
          }
        })
        d.setAttribute("value", r)
        f.setAttribute("value", i)
        if (c) {
          c.setAttribute("value", n)
        }
        if (a) {
          O(e, u, o)
        }
        if (Rs["ConfigValues"]["notify_me_sms_enabled"]) {
          e.Hr(u, ".rsNotifyMeModalPhoneFormLabel")
          e.Hr(u, "input[name='phone']")
        }
        if (e.Gr(u, ".rsNotifyMeModalEmailFormLabel")) {
          I(e, r, u)
        } else {
          R(e, r, u)
        }
      }
      if (l.classList.contains("rsHidden")) {
        e.Hr(l)
        s.setAttribute("aria-expanded", "true")
      } else {
        s.setAttribute("aria-expanded", "false")
        e.Wr(l)
      }
    }
    var R = function (e, t, i) {
      var n = []
      n[r.Pi] = ".rsNotifyMeModalOutOfStockFormLabel"
      n[r.Li] = ".rsNotifyMeModalPreorderFormLabel"
      n[r.Di] = ".rsNotifyMeModalInStockFormLabel"
      Object.keys(n).forEach(function (r) {
        if (r === t) {
          e.Hr(i, n[r])
        } else {
          e.Wr(i, n[r])
        }
      })
    }
    var d = function (r) {
      var e = r.target.querySelector('[name="rsItemId"]').value
      if (!e) {
        return
      }
      var t = document.querySelector(
        '.rsProductOfferContainer[data-rs-item-id="' + e + '"]'
      )
      if (!t) {
        return
      }
      var i = t.querySelector(
        ".rsNotifyMeMessageWrapper .rsNotifyIcon.rsVisible"
      )
      if (!i) {
        return
      }
      i.innerHTML =
        t.dataset["rsSubscribedMessage"] || "Subscribed to notifications"
    }
    var I = function (e, t, i) {
      var n = {}
      n[r.Pi] = ".rsNotifyMeModalOutOfStockSignupMessage"
      n[r.Li] = ".rsNotifyMeModalPreorderSignupMessage"
      n[r.Di] = ".rsNotifyMeModalInStockSignupMessage"
      Object.keys(n).forEach(function (r) {
        if (r === t) {
          e.Hr(i, n[r])
        } else {
          e.Wr(i, n[r])
        }
      })
    }
    var O = function (r, e, t) {
      var i = r.Gr(e, "input[name='firstName']"),
        n = r.Gr(e, "input[name='lastName']")
      r.Hr(e, ".rsNotifyMeModalFirstNameFormLabel")
      r.Hr(e, ".rsNotifyMeModalLastNameFormLabel")
      r.Hr(i)
      r.Hr(n)
      i.required = !!i
      n.required = !!n
      if (t && i) {
        i.addEventListener("invalid", function (r) {
          if (r.target.validity.valueMissing) {
            r.target.setCustomValidity(t)
          } else {
            r.target.setCustomValidity("")
          }
        })
      }
      if (t && n) {
        n.addEventListener("invalid", function (r) {
          if (r.target.validity.valueMissing) {
            r.target.setCustomValidity(t)
          } else {
            r.target.setCustomValidity("")
          }
        })
      }
    }
    this.Re = function (r) {
      if (!r) {
        return
      }
      var e = r.querySelector(".rsNotifyMeModalForm")
      if (!e) {
        return
      }
      _ = new Rs.Ie(r)
    }
    this.Ui = function (t, i, n, e, s) {
      var a = i.querySelector(".rsNotifyMeMessageWrapper"),
        o = {}
      if (!a || !n) {
        return
      }
      o[r.Pi] = ".rsNotifyMeOutOfStockLink"
      o[r.Li] = ".rsNotifyMePreorderLink"
      o[r.Di] = ".rsNotifyMeInStockLink"
      var l = i.getAttribute(r.yi) === r.gi,
        u = !!i.getAttribute(r.Mi),
        d = i.getAttribute(r.bi)
      var f = function (r) {
        r.preventDefault()
        if (l) {
          p(t, a, n, e, s, r.target, u, d)
        } else {
          c(t, n, e, s, u, d)
        }
      }
      Object.keys(o).forEach(function (r) {
        var e = i.querySelector(o[r])
        if (e) {
          e.removeEventListener("click", f)
          if (r === n) {
            t.Hr(e)
            e.setAttribute("aria-expanded", "false")
            if (!e.getAttribute("data-rs-has-click-listener")) {
              e.addEventListener("click", f)
              e.setAttribute("data-rs-has-click-listener", 1)
            }
          } else {
            t.Wr(e)
          }
        }
      })
      t.Hr(a)
    }
  }
  Rs.Ni = {
    Ai: 3,
    wi: 55,
    Fi: function (t, i) {
      const r = t.querySelector(".rsPersonalization")
      if (!r) {
        return
      }
      const e = r.querySelector(".rsPersonalizationButton"),
        n = r.querySelector(".rsPersonalizationCollapse"),
        s = r.querySelector("i")
      const a = n.querySelectorAll('input:not([type="hidden"]), select'),
        o = n.querySelectorAll('input[type="hidden"]')
      e.addEventListener("click", l)
      function l(r) {
        r.preventDefault()
        const e = r.currentTarget
        n.classList.toggle("rsHidden")
        if (n.classList.contains("rsHidden")) {
          s.className = "rsPersonalizationButtonIconPlus"
          e.setAttribute("aria-expanded", "false")
          for (let r = 0; r < a.length; r++) {
            a[r].required = false
            a[r].value = ""
            a[r].disabled = true
          }
          for (let r = 0; r < o.length; r++) {
            o[r].disabled = true
          }
          i.Wr(t, ".rsPersonalizationDelivery")
          i.Hr(t, ".rsDropshipDelivery")
        } else {
          s.className = "rsPersonalizationButtonIconTimes"
          e.setAttribute("aria-expanded", "true")
          for (let r = 0; r < a.length; r++) {
            a[r].required = true
            a[r].disabled = false
          }
          for (let r = 0; r < o.length; r++) {
            o[r].disabled = false
          }
          i.Hr(t, ".rsPersonalizationDelivery")
          i.Wr(t, ".rsDropshipDelivery")
        }
      }
    },
    Bi: function (r) {
      let e = ""
      let t = ""
      const i = r.replace(/ /g, "_")
      t = ""
      for (let r = 1; r <= this.Ai; r++) {
        t +=
          '<input name="rsProductPersonalizationLabel' +
          r +
          '" ' +
          'type="hidden" ' +
          'class="rsProductPersonalizationLabel' +
          r +
          '" ' +
          'value="Personalization ' +
          r +
          '" ' +
          "disabled" +
          ">" +
          '<label for="rsProductPersonalizationValue' +
          r +
          "_" +
          i +
          '" ' +
          'class="rsProductPersonalizationValue' +
          r +
          'Label"' +
          ">" +
          "Custom Label " +
          r +
          "</label>" +
          '<input name="rsProductPersonalizationValue' +
          r +
          '" ' +
          'type="text" ' +
          'class="rsProductPersonalizationValue' +
          r +
          '" ' +
          'placeholder="Personalization ' +
          r +
          '" ' +
          'maxlength="' +
          this.wi +
          '" ' +
          "disabled " +
          'id="rsProductPersonalizationValue' +
          r +
          "_" +
          i +
          '"' +
          ">"
      }
      e =
        '<div class="rsPersonalization">' +
        '<button class="rsPersonalizationButton"' +
        'aria-expanded="false" ' +
        'type="button"' +
        'aria-controls="rsPersonalizationCollapse_' +
        i +
        '"' +
        ">" +
        '<i class="rsPersonalizationButtonIconPlus"></i>' +
        '<span class="rsAddPersonalizationLabel">Add Personalization</span>' +
        "</button>" +
        '<div class="rsPersonalizationCollapse rsHidden" ' +
        'id="rsPersonalizationCollapse_' +
        i +
        '">' +
        t +
        "</div>" +
        "</div>"
      return e
    },
    mi: function (e) {
      for (let r = 1; r <= this.Ai; r++) {
        if (typeof e["rsProductPersonalizationLabel" + r] !== "undefined") {
          if (typeof e["rsProductPersonalizationValue" + r] === "undefined") {
            throw new Error(
              "Personalization label " +
                r +
                " is set, but value " +
                r +
                " is not set"
            )
          }
          if (typeof e["rsProductPersonalizationLabel" + r] !== "string") {
            throw new Error(
              "Personalization label " + r + " is set, but it's not a string"
            )
          }
          if (e["rsProductPersonalizationLabel" + r].length > this.wi) {
            throw new Error(
              "Personalization label " + r + " length is more than " + this.wi
            )
          }
        }
        if (typeof e["rsProductPersonalizationValue" + r] !== "undefined") {
          if (typeof e["rsProductPersonalizationLabel" + r] === "undefined") {
            throw new Error(
              "Personalization value " +
                r +
                " is set, but label " +
                r +
                " is not set"
            )
          }
          if (
            typeof e["rsProductPersonalizationValue" + r] !== "string" &&
            typeof e["rsProductPersonalizationValue" + r] !== "number"
          ) {
            throw new Error(
              "Personalization value " +
                r +
                " is set, but it's not a string or number"
            )
          }
          if (e["rsProductPersonalizationValue" + r].length > this.wi) {
            throw new Error(
              "Personalization value " + r + " length is more than " + this.wi
            )
          }
        }
      }
    },
  }
  Rs.fi = function (r) {
    var d = r,
      f = Boolean(Object.keys(r["shippingOptions"]["best"]).length)
    this.ci = function () {
      return "$" + d["prices"]["sell"]
    }
    this.Hi = function () {
      return d["prices"]["reference"]["price"]
        ? "$" + d["prices"]["reference"]["price"]
        : null
    }
    this.Wi = function (r, e) {
      if (!f) {
        return ""
      }
      var t =
        r !== false
          ? d["shippingOptions"]["best"]["cost"]
          : d["shippingOptions"]["fasterThanBest"][e]["cost"]
      return "$" + t.toFixed(2)
    }
    this.ki = function () {
      if (!f) {
        return null
      }
      var r = parseInt(d["shippingOptions"]["best"]["transitDays"])
      if (r && r <= 2 && d["shippingOptions"]["best"]["cost"] === 0) {
        return r
      }
      return null
    }
    this.xi = function (r, e) {
      if (!f) {
        return ""
      }
      var t = new Date(),
        i = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1),
        n = false,
        s =
          r !== false
            ? d["shippingOptions"]["best"]["getItBy"]
            : d["shippingOptions"]["fasterThanBest"][e]["getItBy"],
        a = ""
      var o = new Date(s.substring(0, 4), s.substring(5, 7) - 1, s.substring(8))
      if (
        i.getFullYear() === o.getFullYear() &&
        i.getMonth() === o.getMonth() &&
        i.getDate() === o.getDate()
      ) {
        n = true
      }
      if (
        d["inventory"]["hasRestockDate"] &&
        !d["inventory"]["inStock"] &&
        o.getFullYear() > i.getFullYear()
      ) {
        a = ", " + o.getFullYear()
      }
      var l = o.toLocaleString("en-US", { month: "short" })
      return (
        (n ? "Tomorrow" : o.toLocaleString("en-US", { weekday: "long" })) +
        ", " +
        l +
        " " +
        o.getDate() +
        a
      )
    }
    this.Vi = function (r, e) {
      if (!f) {
        return ""
      }
      var t = new Date(),
        i =
          r !== false
            ? d["shippingOptions"]["best"]["orderBy"]
            : d["shippingOptions"]["fasterThanBest"][e]["orderBy"],
        n = new Date(i),
        s = n - t,
        a = Math.round(s / 6e4)
      if (a < 0) {
      }
      var o = Math.floor(a / 60),
        l = a % 60,
        u = ""
      if (o > 23) {
        return ""
      }
      if (o > 0) {
        u += o + " " + (o === 1 ? "hr" : "hrs")
      }
      if (l) {
        u += " " + l + (l == 1 ? " min" : " mins")
      } else {
      }
      return u
    }
    this.Gi = function () {
      d["shippingOptions"]["fasterThanBest"].sort(function (r, e) {
        return e["transitDays"] - r["transitDays"]
      })
    }
  }
  Rs.Yi = function () {
    this.zi = function (r) {
      r.innerHTML =
        "<div class='rsMessageContainer'></div>" +
        "<div class='rsPriceContainer'></div>" +
        "<div class='rsShippingContainer'></div>" +
        "<div class='rsAddToCartContainer'></div>"
    }
  }
  Rs.Zi = function (r, T) {
    var h = r,
      A = this,
      d = new Rs._i()
    var N = function (r) {
      h.Wr(r, ".rsLoadingMessage")
      h.Wr(r, ".rsPriceWrapper")
      h.Wr(r, ".rsReferencePriceWrapper")
      h.Wr(r, ".rsReferencePriceMessageWrapper")
      h.Wr(r, ".rsFreeShippingTransitDays")
      h.Wr(r, ".rsFreeShippingTransitDaysLabel")
      h.Wr(r, ".rsFreeNDayShippingWrapper")
      h.Wr(r, ".rsInventoryLowStockQuantityWrapper")
      h.Wr(r, ".rsInventoryOutOfStockPreorder")
      h.Wr(r, ".rsInventoryOutOfStock")
      h.Wr(r, ".rsShippingEstimateWrapper")
      h.Wr(r, ".rsShippingGetItByWrapper")
      h.Wr(r, ".rsShippingOrderWithinWrapper")
      h.Wr(r, ".rsFasterShippingWrapper")
      h.Wr(r, ".rsNotifyMeMessageWrapper")
      h.Wr(r, ".rsCallToOrder")
      h.Wr(r, ".rsAddToCartForm")
      h.Wr(r, ".rsErrorMessage")
      h.Wr(r, ".rsItemQtySelect")
      h.Wr(r, ".rsItemQtySelectLabelText")
      h.Wr(r, ".rsItemQtySelectLabel")
      h.Wr(r, ".rsElectronicDelivery")
      h.Wr(r, ".rsDropshipDelivery")
      h.Wr(r, ".rsAffirmProductMessage")
      h.Wr(r, ".rsPersonalizationDelivery")
    }
    var m = function (r) {
      var e = r.getAttribute("data-rs-item-url")
      if (e) {
        if (e == "{rs_autofill_url}") {
          e = window.location.href
        }
      } else {
        e = ""
      }
      return e
    }
    var f = function (r, e) {
      if (!e["inventory"]["inStock"]) {
        if (e["inventory"]["isNewlyReceived"]) {
          return (
            r.getAttribute(
              "data-rs-out-of-stock-preorder-submit-button-label"
            ) || r.getAttribute("data-rs-submit-button-label")
          )
        }
        return (
          r.getAttribute("data-rs-out-of-stock-submit-button-label") ||
          r.getAttribute("data-rs-submit-button-label")
        )
      }
      return r.getAttribute("data-rs-submit-button-label")
    }
    this.ji = function (r, e, t) {
      var i = h.Gr(r, ".rsAddToCartForm")
      if (i) {
        var n = m(r),
          s = i.getAttribute("data-rs-item-qty-select-label") || "",
          a = r.getAttribute("data-rs-item-list-index") || 0,
          o = r.getAttribute("data-rs-item-list-name") || "",
          l = r.getAttribute("data-rs-item-list-id") || "",
          u = r.getAttribute("data-rs-related-items")
        i.innerHTML =
          '<form action="' +
          h.zr() +
          '" class="rsForm" method="post" target="_parent">' +
          '<input type="hidden" name="rsItemUrl" value="' +
          n +
          '">' +
          '<input type="hidden" name="rsItemId" value="' +
          e +
          '">' +
          '<input type="hidden" name="rsListIndex" value="' +
          a +
          '">' +
          '<input type="hidden" name="rsListName" value="' +
          o +
          '">' +
          '<input type="hidden" name="rsListId" value="' +
          l +
          '">' +
          (u
            ? '<input type="hidden" name="rsRelatedItemSkus" value="' + u + '">'
            : "") +
          (t["isPersonalizable"] ? Rs.Ni.Bi(e) : "") +
          "<label>" +
          '<span class="rsItemQtySelectLabelText rsHidden" aria-hidden="true">' +
          s +
          "</span>" +
          '<select class="rsItemQtySelect rsHidden" aria-hidden="true" name="quantity">' +
          '<option value="1" selected>1</option>' +
          '<option value="2">2</option>' +
          '<option value="3">3</option>' +
          '<option value="4">4</option>' +
          '<option value="5">5</option>' +
          '<option value="6">6</option>' +
          '<option value="7">7</option>' +
          '<option value="8">8</option>' +
          '<option value="9">9</option>' +
          '<option value="10">10</option>' +
          "</select>" +
          "</label>" +
          '<input type="submit" tabindex="0" value="' +
          f(i, t) +
          '" />' +
          "</form>"
        if (d.vi(i, t)) {
          h.Hr(i, ".rsItemQtySelect")
          h.Hr(i, ".rsItemQtySelectLabelText")
        }
        h.Hr(r, ".rsAddToCartForm")
      }
    }
    this.Qi = function (r, e) {
      var t = e.Ki,
        i = new e.qi(r),
        n = null
      N(t)
      var s = i.ci()
      h.Yr(t, ".rsPrice", s)
      h.Hr(t, ".rsPriceWrapper")
      if (r["prices"]["reference"]["price"]) {
        var a = i.Hi()
        h.Yr(t, ".rsReferencePriceWrapper .rsReferencePrice", a)
        h.Hr(t, ".rsReferencePriceWrapper")
      }
      if (r["prices"]["reference"]["message"]) {
        h.Yr(
          t,
          ".rsReferencePriceMessageWrapper .rsReferencePriceMessage",
          r["prices"]["reference"]["message"]
        )
        h.Hr(t, ".rsReferencePriceMessageWrapper")
      }
      if (r["isEligibleForAffirm"] && typeof affirm !== "undefined") {
        var o = h.Gr(t, ".rsAffirmProductMessage")
        if (o) {
          o.setAttribute("data-amount", r["prices"]["sell"] * 100)
          if (!o.hasAttribute("data-page-type")) {
            o.setAttribute("data-page-type", "product")
          }
          o.classList.add("affirm-as-low-as")
          affirm["ui"].ready(function () {
            affirm["ui"].refresh()
          })
          h.Hr(t, ".rsAffirmProductMessage")
        }
      }
      if (Object.keys(r["shippingOptions"]["best"]).length) {
        if (!r["hasElectronicDelivery"]) {
          var l = i.xi()
          if (r["inventory"]["inStock"]) {
            if (!r["shippingOptions"]["best"]["isDs"]) {
              const E = i.Vi()
              if (E) {
                h.Yr(t, ".rsShippingOrderWithinWrapper .rsOrderWithin", E)
                h.Hr(t, ".rsShippingOrderWithinWrapper")
              }
              h.Yr(t, ".rsShippingGetItByWrapper .rsGetItBy", l)
              h.Hr(t, ".rsShippingEstimateWrapper")
              h.Hr(t, ".rsShippingGetItByWrapper")
            } else {
              h.Hr(t, ".rsDropshipDelivery")
            }
            if (r["inventory"]["lowStockQuantity"]) {
              h.Yr(t, ".rsLowStockQuantity", r["inventory"]["lowStockQuantity"])
              h.Hr(t, ".rsInventoryLowStockQuantityWrapper")
            }
            n = T.Di
          } else {
            h.Hr(
              t,
              r["inventory"]["isNewlyReceived"]
                ? ".rsInventoryOutOfStockPreorder"
                : ".rsInventoryOutOfStock"
            )
            if (r["inventory"]["hasRestockDate"]) {
              h.Yr(t, ".rsShippingGetItByWrapper .rsGetItBy", l)
              h.Hr(t, ".rsShippingEstimateWrapper")
              h.Hr(t, ".rsShippingGetItByWrapper")
            }
            n = r["inventory"]["isNewlyReceived"] ? T.Li : T.Pi
          }
          if (!r["shippingOptions"]["best"]["cost"]) {
            var u = i.ki(),
              d = h.Gr(t, ".rsFreeShippingTransitDaysLabel")
            if (u) {
              h.Yr(t, ".rsFreeShippingTransitDays", u)
              h.Hr(t, ".rsFreeShippingTransitDays")
              h.Hr(d)
              h.Hr(t, ".rsFreeNDayShippingWrapper")
            } else if (d) {
              h.Hr(t, ".rsFreeNDayShippingWrapper")
            }
          }
          if (
            r["shippingOptions"]["fasterThanBest"].length &&
            (r["inventory"]["inStock"] || r["inventory"]["hasRestockDate"])
          ) {
            var f = t.querySelector(".rsFasterShippingWrapper"),
              c = t.querySelector(".rsFasterShippingOptionTemplate"),
              p = t.querySelector(".rsFasterShippingLabel"),
              _ = t.querySelector(".rsPopoverWrapper"),
              v = t.querySelector(".rsPopoverBody")
            if (v && c && p) {
              v.innerHTML = ""
              i.Gi()
              for (
                var R = 0;
                R < r["shippingOptions"]["fasterThanBest"].length;
                R++
              ) {
                var I = i.Vi(false, R),
                  O = c.cloneNode(true),
                  S = i.Wi(false, R)
                l = i.xi(false, R)
                if (r["inventory"]["inStock"] && I) {
                  h.Yr(O, ".rsOrderWithin", I)
                  h.Hr(O, ".rsFasterShippingOrderWithinWrapper")
                }
                h.Yr(O, ".rsFasterShippingCost", S)
                h.Yr(O, ".rsGetItBy", l)
                h.Hr(O)
                v.appendChild(O)
              }
              _ = new Rs.Ur(_)
              p.addEventListener("click", function (r) {
                r.preventDefault()
                _.open(this)
              })
              h.Hr(f)
            }
          }
        } else {
          h.Hr(t, ".rsElectronicDelivery")
        }
      }
      T.Ui(h, t, n, e.itemId, m(t))
      if (r["isOnlyPhoneOrderable"]) {
        h.Hr(t, ".rsCallToOrder")
      } else {
        A.ji(t, e.itemId, r)
        Rs.Ni.Fi(t, h, r)
      }
    }
    this.Xi = function (r, e) {
      var t = r.Ki
      N(t)
      if (typeof e === "undefined") {
        e = true
      }
      if (e) {
        h.Hr(t, ".rsErrorMessage")
      }
    }
  }
  Rs._i = function () {
    this.vi = function (r, e) {
      if (!r.classList.contains("rsWithItemQtySelect")) {
        return false
      }
      if (!e["allowQtySelection"]) {
        return false
      }
      var t = r.getAttribute("data-rs-qty-select-min-price")
      if (null !== t) {
        var i = parseFloat(t)
        if (isNaN(i)) {
          Rs.Qr.send(Rs.p.m, { min: t })
          return false
        }
        if (parseFloat(e["prices"]["sell"]) < i) {
          return false
        }
      }
      var n = r.getAttribute("data-rs-qty-select-max-price")
      if (null !== n) {
        var s = parseFloat(n)
        if (isNaN(s)) {
          Rs.Qr.send(Rs.p.C, { max: n })
          return false
        }
        if (parseFloat(e["prices"]["sell"]) > s) {
          return false
        }
      }
      return true
    }
  }
  Rs.Ji = function (d, r) {
    var f = new Rs.wr(),
      l = new Rs.Zi(f, r)
    this.$i = function (r) {
      var e = r.getAttribute("data-rs-integration-style"),
        t = r.getAttribute("data-rs-item-id"),
        i = parseInt(r.getAttribute("data-rs-priority")),
        n = { Ki: r },
        s = {}
      s["poContainerHtml"] = r.outerHTML
      if (isNaN(i)) {
        i = 1
      }
      if (!t) {
        Rs.Qr.send(Rs.p.R, s)
        l.Xi(n)
        return
      }
      if (e !== "default" && e !== "hybrid" && e !== "component") {
        Rs.Qr.send(Rs.p.I, s)
        l.Xi(n)
        return
      }
      if (e === "default") {
        var a = new Rs.Yi()
        a.zi(r)
      }
      if (e === "default" || e === "hybrid") {
        var o = new Rs.rn(
          new Rs.Kt(Rs["ReplacementText"]["placeholderToReplacementTextMap"])
        )
        o.ei(r)
      }
      n.itemId = t
      n.qi = Rs.fi
      d.getItem(t, l.Qi, l.Xi, n, i)
    }
    this.en = function (r) {
      var e = r.getAttribute("data-rs-integration-style"),
        t = r.getAttribute("data-rs-item-ids"),
        i = parseInt(r.getAttribute("data-rs-priority")),
        n = {},
        s = new Rs.tn(f)
      n["paContainerHtml"] = r.outerHTML
      if (!t) {
        Rs.Qr.send(Rs.p.A, n)
        s.nn(r)
        return
      }
      var a = t.split(",")
      if (isNaN(i)) {
        i = 1
      }
      if (e !== "default" && e !== "hybrid" && e !== "component") {
        Rs.Qr.send(Rs.p.N, n)
        s.Xi(r)
        return
      }
      if (e === "default") {
        var o = new Rs.sn()
        o.zi(r)
      }
      if (e === "default" || e === "hybrid") {
        var l = new Rs.an(
          new Rs.Kt(Rs["ReplacementText"]["placeholderToReplacementTextMap"])
        )
        l.ei(r)
      }
      var u = new Rs.on(s, r, a)
      a.forEach(function (r) {
        d.getItem(r, u.Ii, u.Ei, { itemId: r, qi: Rs.fi }, i)
      })
    }
    this.ln = function (r) {
      var e = r.getAttribute("data-rs-item-id")
      d.getItem(
        e,
        function (r, e) {
          f.Hr(e.un)
        },
        function (r, e) {
          f.Wr(r.un)
        },
        { un: r }
      )
    }
    this.dn = function (r, e, t) {
      if (!e) {
        Rs.Qr.send(Rs.p.S)
        l.Xi({ Ki: r })
        return
      }
      if (r.getAttribute("data-rs-item-id") == e) {
        return
      }
      r.setAttribute("data-rs-item-id", e)
      r.setAttribute("data-rs-item-url", t ? t : "")
      this.$i(r)
      d.flush()
    }
    this.fn = function (e) {
      var r = function () {
        var r = e.querySelectorAll("[data-rs-new-item-id]"),
          t = null
        if (e.classList.contains("rsRemoveUnorderableOptions")) {
          t = function (r, e) {
            r.cn.remove()
          }
        }
        Array.prototype.forEach.call(r, function (r) {
          var e = r.getAttribute("data-rs-new-item-id")
          if (!e) {
            return
          }
          d.getItem(e, null, t, t ? { cn: r } : null, t ? 1 : 2)
        })
      }
      var t = e.querySelector("select option:first-child")
      if (t && !t.selected) {
        t.selected = true
      }
      r()
      if (e.classList.contains("rsAutoUpdateProductOfferContainer")) {
        e.onchange = function (r) {
          var e = Rs.Events.createEvent(
              Rs.Events.UPDATE_PRODUCT_OFFER_CONTAINER_WITH_NEW_ITEM
            ),
            t = null,
            i = null
          if (typeof r.target.selectedIndex !== "undefined") {
            t = r.target[r.target.selectedIndex]
          } else {
            t = r.target
          }
          i = document.querySelector(
            "#" +
              t.form.getAttribute(
                "data-rs-associated-product-offer-container-id"
              )
          )
          if (!i) {
            Rs.Qr.send(Rs.p.O)
            return
          }
          e["newItemId"] = t.getAttribute("data-rs-new-item-id")
          e["newItemUrl"] = t.getAttribute("data-rs-new-item-url")
          i.dispatchEvent(e)
        }
      }
    }
    this.pn = function (r) {
      var e = new Rs.rn(
        new Rs.Kt(Rs["ReplacementText"]["placeholderToReplacementTextMap"])
      )
      e.pn(r)
    }
  }
  Rs._n = new (function () {
    var n = function (r) {
      if (typeof r !== "object") {
        return Rs.p.G
      }
      if (Array.isArray(r) && !r.length) {
        return true
      }
      if (typeof r["cost"] === "undefined" || r["cost"] === "") {
        return Rs.p.Y
      }
      if (typeof r["label"] !== "string" || r["label"] === "") {
        return Rs.p.nr
      }
      if (
        typeof r["transitDays"] === "undefined" ||
        r["transitDays"] === "" ||
        isNaN(r["transitDays"])
      ) {
        return Rs.p.Z
      }
      if (typeof r["isDs"] !== "boolean") {
        return Rs.p.er
      }
      var e = /^(\d{4})-(\d{2})-(\d{2})$/,
        t =
          /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})\.(\d{3})[+-](\d{2}):(\d{2})$/
      if (typeof r["getItBy"] === "undefined" || !r["getItBy"].match(e)) {
        return Rs.p.j
      }
      if (typeof r["orderBy"] === "undefined" || !r["orderBy"].match(t)) {
        return Rs.p.K
      }
      var i = new Date(),
        n = r["orderBy"].substr(-6),
        s = new Date(r["getItBy"] + "T00:00:00.000" + n),
        a = new Date(r["orderBy"])
      if (s.toString() === "Invalid Date" || isNaN(s)) {
        return Rs.p.q
      }
      if (a.toString() === "Invalid Date" || isNaN(a)) {
        return Rs.p.X
      }
      if (a < i) {
        return Rs.p.J
      }
      if (s < i) {
        return Rs.p.$
      }
      if (s < a) {
        return Rs.p.rr
      }
      return true
    }
    this.validate = function (r) {
      if (typeof r !== "object") {
        return Rs.p.g
      }
      if (typeof r["isOnlyPhoneOrderable"] !== "boolean") {
        return Rs.p.U
      }
      if (typeof r["allowQtySelection"] !== "boolean") {
        return Rs.p.ur
      }
      if (typeof r["inventory"] !== "object") {
        return Rs.p.F
      }
      if (typeof r["inventory"]["inStock"] !== "boolean") {
        return Rs.p.B
      }
      if (
        typeof r["inventory"]["hasRestockDate"] === "undefined" ||
        (!r["inventory"]["inStock"] &&
          typeof r["inventory"]["hasRestockDate"] !== "boolean")
      ) {
        return Rs.p.H
      }
      if (typeof r["prices"] !== "object") {
        return Rs.p.W
      }
      if (
        typeof r["prices"]["list"] === "undefined" ||
        r["prices"]["list"] === "" ||
        r["prices"]["list"] === 0
      ) {
        return Rs.p.k
      }
      if (
        typeof r["prices"]["sell"] === "undefined" ||
        r["prices"]["sell"] === "" ||
        r["prices"]["sell"] === 0
      ) {
        return Rs.p.V
      }
      if (typeof r["prices"]["reference"] !== "object") {
        return Rs.p.sr
      }
      if (
        typeof r["prices"]["reference"]["price"] === "undefined" ||
        r["prices"]["reference"]["price"] === "" ||
        r["prices"]["reference"]["price"] === 0
      ) {
        return Rs.p.ar
      }
      if (
        typeof r["prices"]["reference"]["message"] !== "string" &&
        r["prices"]["reference"]["message"] !== null
      ) {
        return Rs.p.lr
      }
      if (typeof r["shippingOptions"] !== "object") {
        return Rs.p.tr
      }
      if (typeof r["hasElectronicDelivery"] !== "boolean") {
        return Rs.p.dr
      }
      if (typeof r["isEligibleForAffirm"] !== "boolean") {
        return Rs.p.cr
      }
      var e
      if (true !== (e = n(r["shippingOptions"]["best"]))) {
        return e
      }
      if (
        typeof r["shippingOptions"]["fasterThanBest"] !== "object" ||
        !Array.isArray(r["shippingOptions"]["fasterThanBest"])
      ) {
        return Rs.p.ir
      }
      for (var t = 0; t < r["shippingOptions"]["fasterThanBest"].length; t++) {
        var i = r["shippingOptions"]["fasterThanBest"][t]
        if (true !== (e = n(i))) {
          return e
        }
      }
      return true
    }
  })()
  Rs.rn = function (r) {
    var u = r
    this.ei = function (r) {
      if (!(r instanceof Element)) {
        Rs.Qr.send(Rs.p.T)
        return
      }
      var e =
        "<div class='rsLoadingMessage rsVisible' aria-label='Loading Message' aria-hidden='false'>" +
        "RS_PRODUCT_LOADING_MESSAGE" +
        "</div>" +
        "<div class='rsErrorMessage rsHidden' role='alert' aria-label='Error Message' aria-hidden='true'>" +
        "RS_PRODUCT_ERROR_MESSAGE" +
        "</div>"
      u.qt(r, ".rsMessageContainer", e)
      e =
        "<div class='rsPricingWrapper'>" +
        "<div class='rsReferencePriceWrapper rsHidden' aria-hidden='true'>" +
        "<span class='rsReferencePrice'></span>" +
        "</div>" +
        "<div class='rsPriceWrapper rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_PRICE_LABEL <span class='rsPrice'></span>" +
        "</div>" +
        "<div class='rsReferencePriceMessageWrapper rsHidden' aria-hidden='true'>" +
        "<span class='rsReferencePriceMessage'></span>" +
        "</div>" +
        "</div>"
      u.qt(r, ".rsPriceContainer", e)
      var t = u.$t("rsPopoverWrapper"),
        i = t + "-fasterShippingLabel"
      e =
        "<div class='rsFreeNDayShippingWrapper rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_FREE_SHIPPING_LABEL_START <span class='rsFreeShippingTransitDays rsHidden' aria-hidden='true'></span><span class='rsFreeShippingTransitDaysLabel rsHidden' aria-hidden='true'>RS_PRODUCT_FREE_SHIPPING_LABEL_DAY </span>RS_PRODUCT_FREE_SHIPPING_LABEL_END" +
        "</div> " +
        "<div class='rsInventoryLowStockQuantityWrapper rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_INVENTORY_LOW_STOCK_START <span class='rsLowStockQuantity'></span> RS_PRODUCT_INVENTORY_LOW_STOCK_END" +
        "</div>" +
        "<div class='rsInventoryOutOfStockPreorder rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_INVENTORY_OUT_OF_STOCK_PREORDER" +
        "</div>" +
        "<div class='rsInventoryOutOfStock rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_INVENTORY_OUT_OF_STOCK" +
        "</div>" +
        "<div class='rsElectronicDelivery rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_ELECTRONIC_DELIVERY" +
        "</div>" +
        "<div class='rsDropshipDelivery rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_DROPSHIP_DELIVERY" +
        "</div>" +
        "<div class='rsPersonalizationDelivery rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_PERSONALIZATION_DELIVERY" +
        "</div>" +
        "<div class='rsShippingEstimateWrapper'>" +
        "<span class='rsShippingGetItByWrapper rsHidden' aria-hidden='true'>" +
        " RS_PRODUCT_SHIPPING_GET_IT_BY_LABEL " +
        "<span class='rsGetItBy'></span>" +
        "</span>" +
        "<span class='rsShippingOrderWithinWrapper rsHidden' aria-hidden='true'>" +
        " RS_PRODUCT_SHIPPING_ORDER_BY_LABEL " +
        "<span class='rsOrderWithin'></span>" +
        "</span>" +
        "</div>" +
        "<div class='rsFasterShippingWrapper rsHidden' aria-hidden='true' role='tooltip'>" +
        "<div class='rsFasterShippingOptionTemplate rsHidden' aria-hidden='true'>" +
        "<span class='rsFasterShippingGetItByWrapper'>" +
        "RS_PRODUCT_SHIPPING_GET_IT_BY_LABEL " +
        "<span class='rsGetItBy'></span>" +
        "</span>" +
        "<span class='rsFasterShippingOrderWithinWrapper rsHidden' aria-hidden='true'>" +
        " RS_PRODUCT_SHIPPING_ORDER_BY_LABEL " +
        "<span class='rsOrderWithin'></span>" +
        "</span>" +
        "&nbsp;&nbsp;<span class='rsFasterShippingCost'></span><br>" +
        "</div>" +
        "<div id='" +
        t +
        "' data-rs-popover-trigger-element-id='" +
        i +
        "' class='rsPopoverWrapper rsAutoPosition rsHidden' aria-hidden='true' role='tooltip'>" +
        "<span class='rsPopoverClose rsPopoverCloseX' tabindex='0' aria-label='close' role='button'><span aria-hidden='true'>&times;</span></span>" +
        "<div class='rsPopoverBody'></div>" +
        "<span class='rsPopoverTriangle'></span>" +
        "</div>" +
        "<a id='" +
        i +
        "' href='#' class='rsFasterShippingLabel' aria-controls='" +
        t +
        "' aria-expanded='false' role='button'>RS_PRODUCT_FASTER_SHIPPING_LABEL</a>" +
        "</div>"
      u.qt(r, ".rsShippingContainer", e)
      e =
        "<div class='rsNotifyMeMessageWrapper rsHidden' aria-hidden='true'>" +
        "<a href='#' class='rsNotifyMeOutOfStockLink rsNotifyIcon rsHidden' aria-hidden='true'>RS_PRODUCT_NOTIFY_ME_OUT_OF_STOCK_LINK</a>" +
        "<a href='#' class='rsNotifyMePreorderLink rsNotifyIcon rsHidden' aria-hidden='true'>RS_PRODUCT_NOTIFY_ME_PREORDER_LINK</a>" +
        "<a href='#' class='rsNotifyMeInStockLink rsNotifyIcon rsHidden' aria-hidden='true'>RS_PRODUCT_NOTIFY_ME_IN_STOCK_LINK</a>" +
        "<div class='rsNotifyMeFormAccordionWrapper rsHidden' aria-hidden='true' data-rs-subscribed-message='RS_PRODUCT_NOTIFY_ME_ACCORDION_SUBSCRIBED'></div>" +
        "</div>"
      u.qt(r, ".rsNotifyMeMessageContainer", e)
      r.querySelectorAll(".rsAffirmFinancingContainer").forEach(function (r) {
        var e = u.Jt(r, ["data-page-type"])
        var t =
          "<p class='rsAffirmProductMessage rsHidden' " +
          e +
          " aria-hidden='true'></p>"
        u.qt(r, null, t)
      })
      r.querySelectorAll(".rsAddToCartContainer").forEach(function (r) {
        var e = u.Xt(r, [
          "rsWithItemQtySelect",
          "rsWithContinueShoppingModal",
          "rsNoGoToCart",
          "rsWithMiniCartModal",
        ])
        var t = u.Jt(r, [
          "data-rs-qty-select-min-price",
          "data-rs-qty-select-max-price",
          "data-rs-out-of-stock-submit-button-label",
          "data-rs-out-of-stock-preorder-submit-button-label",
        ])
        var i =
          "<div class='rsCallToOrder rsHidden' aria-hidden='true'>" +
          "RS_PRODUCT_CALL_TO_ORDER_MESSAGE" +
          "</div>" +
          "<div " +
          "class='rsAddToCartForm " +
          e.join(" ") +
          "' " +
          "data-rs-submit-button-label='RS_PRODUCT_ADD_TO_CART_SUBMIT_BUTTON_LABEL' " +
          "data-rs-item-qty-select-label='RS_PRODUCT_ITEM_QTY_SELECT_LABEL'" +
          t +
          ">" +
          "</div>"
        u.qt(r, null, i)
      })
    }
    this.pn = function (r) {
      var e = u.$t("rsNotifyMeModal"),
        t = e + "-submit",
        i = e + "-email",
        n = e + "-phone",
        s = e + "-first-name",
        a = e + "-last-name",
        o = e + "-newsletter"
      var l =
        "<div class='rsModalWrapper rsNotifyMeModalWrapper rsHidden' aria-hidden='true'>" +
        "<div class='rsModalOverlay'></div>" +
        "<div class='rsModal' role='dialog' aria-labelledby='" +
        e +
        "'>" +
        "<div class='rsModalHeader'>" +
        "<span class='rsModalTitle' id='" +
        e +
        "'>RS_PRODUCT_NOTIFY_ME_MODAL_LABEL</span>" +
        "<span class='rsModalCloseButton rsModalCloseX' role='button' aria-label='Close' tabindex='0'>&times;</span>" +
        "</div>" +
        "<div class='rsModalBody'>" +
        "<form class='rsNotifyMeModalForm'>" +
        "<p class='rsHidden rsNotifyMeModalOutOfStockSignupMessage'>RS_PRODUCT_NOTIFY_ME_OUT_OF_STOCK_SIGNUP_MESSAGE</p>" +
        "<p class='rsHidden rsNotifyMeModalPreorderSignupMessage'>RS_PRODUCT_NOTIFY_ME_PREORDER_SIGNUP_MESSAGE</p>" +
        "<p class='rsHidden rsNotifyMeModalInStockSignupMessage'>RS_PRODUCT_NOTIFY_ME_IN_STOCK_SIGNUP_MESSAGE</p>" +
        "<label class='rsNotifyMeModalFirstNameFormLabel rsHidden' for='" +
        s +
        "'>RS_PRODUCT_NOTIFY_ME_FIRST_NAME_FORM_LABEL</label>" +
        "<input class='rsNotifyMeModalInput rsHidden' id='" +
        s +
        "' aria-labelledby='" +
        t +
        "' name='firstName' type='text' placeholder='RS_PRODUCT_NOTIFY_ME_FIRST_NAME_PLACEHOLDER_LABEL'>" +
        "<label class='rsNotifyMeModalLastNameFormLabel rsHidden' for='" +
        a +
        "'>RS_PRODUCT_NOTIFY_ME_LAST_NAME_FORM_LABEL</label>" +
        "<input class='rsNotifyMeModalInput rsHidden' id='" +
        a +
        "' aria-labelledby='" +
        t +
        "' name='lastName' type='text' placeholder='RS_PRODUCT_NOTIFY_ME_LAST_NAME_PLACEHOLDER_LABEL'>" +
        "<label class='rsNotifyMeModalPhoneFormLabel rsHidden' for='" +
        n +
        "'>RS_PRODUCT_NOTIFY_ME_PHONE_FORM_LABEL</label>" +
        "<input class='rsNotifyMeModalInput rsHidden' id='" +
        n +
        "' aria-labelledby='" +
        t +
        "' name='phone' type='tel' placeholder='RS_PRODUCT_NOTIFY_ME_PHONE_PLACEHOLDER_LABEL'>" +
        "<label class='rsNotifyMeModalEmailFormLabel' for='" +
        i +
        "'>RS_PRODUCT_NOTIFY_ME_EMAIL_FORM_LABEL</label>" +
        "<input class='rsNotifyMeModalInput' id='" +
        i +
        "' aria-labelledby='" +
        t +
        "' name='email' type='email' placeholder='RS_PRODUCT_NOTIFY_ME_EMAIL_PLACEHOLDER_LABEL'>" +
        "<input class='rsNotifyMeModalInput' aria-labelledby='" +
        t +
        "' name='rsItemId' type='hidden'>" +
        "<input class='rsNotifyMeModalInput' aria-labelledby='" +
        t +
        "' name='rsItemUrl' type='hidden'>" +
        "<input class='rsNotifyMeModalInput' aria-labelledby='" +
        t +
        "' name='itemStatus' type='hidden'>" +
        "<input class='rsNotifyMeModalInput' id='" +
        o +
        "' aria-labelledby='" +
        t +
        "' name='newsletter' type='checkbox' value='1'>" +
        "<label for='" +
        o +
        "'>RS_PRODUCT_NOTIFY_ME_NEWSLETTER_LABEL</label>" +
        "<button type='submit' id='" +
        t +
        "' class='rsNotifyMeModalSubmit'>RS_PRODUCT_NOTIFY_ME_SUBMIT_LABEL</button>" +
        "</form>" +
        "</div>" +
        "</div>" +
        "</div>" +
        "</div>"
      u.qt(r, null, l)
    }
  }
  Rs.on = function (r, e, t) {
    var i = t
    var n = []
    var s = false
    var a = function () {
      var I,
        O,
        S = [],
        E,
        T,
        h,
        A,
        N,
        m,
        C = true,
        P = true,
        L = true,
        D = true,
        y = true,
        M = false,
        b
      n.forEach(function (r) {
        var e = r.productDataObj,
          t = parseFloat(e["prices"]["sell"]),
          i = Boolean(Object.keys(e["shippingOptions"]["best"]).length),
          n = 0,
          s = false,
          a = null,
          o = null
        if (i) {
          D = false
          n = parseFloat(e["shippingOptions"]["best"]["cost"])
          s = e["shippingOptions"]["best"]["isDs"]
          a = new Date(
            e["shippingOptions"]["best"]["getItBy"].substring(0, 4),
            e["shippingOptions"]["best"]["getItBy"].substring(5, 7) - 1,
            e["shippingOptions"]["best"]["getItBy"].substring(8)
          )
          o = new Date(
            e["shippingOptions"]["best"]["orderBy"].substring(0, 4),
            e["shippingOptions"]["best"]["orderBy"].substring(5, 7) - 1,
            e["shippingOptions"]["best"]["orderBy"].substring(8)
          )
        }
        if (!i || n) {
          y = false
        }
        if (!I || t < I) {
          I = t
          M = e["isEligibleForAffirm"]
        }
        if (!O || t > O) {
          O = t
        }
        if (!e["inventory"]["isNewlyReceived"]) {
          C = false
        }
        if (!e["inventory"]["lowStockQuantity"]) {
          P = false
        } else if (!b || e["inventory"]["lowStockQuantity"] > b) {
          b = e["inventory"]["lowStockQuantity"]
        }
        if (!e["hasElectronicDelivery"]) {
          L = false
        }
        if (!e["inventory"]["inStock"]) {
          if (e["inventory"]["hasRestockDate"] && i && (!N || a < m)) {
            m = a
            N = r
          }
          return
        }
        if (S.length === 0 && i) {
          E = a
          T = o
          h = n
          A = s
          S = [r]
          return
        }
        if (s && !A) {
          return
        }
        var l = i && n < h,
          u = i && n === h,
          d = i && a < E,
          f = i && a === E,
          c = i && o > T,
          p = i && o === T,
          _ = A && !s,
          v = u && f && p,
          R = l || (u && d) || (u && f && c)
        if (_ || R) {
          E = a
          T = o
          h = n
          A = s
          S = [r]
        } else if (v) {
          S.push(r)
        }
      })
      var r = S.length ? S[Math.floor(Math.random() * S.length)] : null
      return {
        vn: I.toFixed(2),
        Rn: O.toFixed(2),
        In: r,
        On: N,
        Sn: C,
        En: P ? b : null,
        Tn: D,
        hn: y,
        An: L,
        Nn: M,
      }
    }
    var o = function () {
      if (i.length > 0) {
        return
      }
      if (n.length === 0) {
        r.nn(e, s)
        return
      }
      r.mn(a(), e)
    }
    var l = function (r) {
      var e = false,
        t
      while ((t = i.indexOf(r)) > -1) {
        i.splice(t, 1)
        e = true
      }
      if (!e) {
        throw new Error("Invalid itemId received for product aggregate.")
      }
    }
    this.Ii = function (r, e) {
      l(e.itemId)
      n.push({ context: e, productDataObj: r })
      o()
    }
    this.Ei = function (r, e) {
      l(r.itemId)
      if (typeof e === "undefined") {
        e = true
      }
      if (e) {
        s = true
      }
      o()
    }
  }
  Rs.sn = function () {
    this.zi = function (r) {
      r.innerHTML =
        "<div class='rsMessageContainer'></div>" +
        "<div class='rsPriceContainer'></div>" +
        "<div class='rsShippingContainer'></div>"
    }
  }
  Rs.an = function (r) {
    var i = r
    this.ei = function (r) {
      if (!(r instanceof Element)) {
        Rs.Qr.send(Rs.p.T)
        return
      }
      var e =
        "<div class='rsLoadingMessage rsVisible' aria-hidden='false'>" +
        "RS_PRODUCT_LOADING_MESSAGE" +
        "</div>" +
        "<div class='rsErrorMessage rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_ERROR_MESSAGE" +
        "</div>"
      i.qt(r, ".rsMessageContainer", e)
      e =
        "<div class='rsPriceWrapper rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_PRICE_LABEL <span class='rsPrice'></span> " +
        "</div>" +
        "<div class='rsPriceRangeWrapper rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_MIN_PRICE_LABEL <span class='rsMinPrice'></span> " +
        "</div>"
      i.qt(r, ".rsPriceContainer", e)
      r.querySelectorAll(".rsAffirmFinancingContainer").forEach(function (r) {
        var e = i.Jt(r, ["data-page-type"])
        var t =
          "<p class='rsAffirmProductMessage rsHidden' " +
          e +
          "aria-hidden='true'></p>"
        i.qt(r, null, t)
      })
      e =
        "<div class='rsFreeNDayShippingWrapper rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_FREE_SHIPPING_LABEL_START <span class='rsFreeShippingTransitDays rsHidden' aria-hidden='true'></span><span class='rsFreeShippingTransitDaysLabel rsHidden' aria-hidden='true'>RS_PRODUCT_FREE_SHIPPING_LABEL_DAY </span>RS_PRODUCT_FREE_SHIPPING_LABEL_END" +
        "</div> " +
        "<div class='rsInventoryLowStockQuantityWrapper rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_INVENTORY_LOW_STOCK_START <span class='rsLowStockQuantity'></span> RS_PRODUCT_INVENTORY_LOW_STOCK_END" +
        "</div>" +
        "<div class='rsInventoryOutOfStockPreorder rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_INVENTORY_OUT_OF_STOCK_PREORDER" +
        "</div>" +
        "<div class='rsInventoryOutOfStock rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_INVENTORY_OUT_OF_STOCK" +
        "</div>" +
        "<div class='rsElectronicDelivery rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_ELECTRONIC_DELIVERY" +
        "</div>" +
        "<div class='rsDropshipDelivery rsHidden' aria-hidden='true'>" +
        "RS_PRODUCT_DROPSHIP_DELIVERY" +
        "</div>" +
        "<div class='rsShippingEstimateWrapper'>" +
        "<span class='rsShippingGetItByWrapper rsHidden' aria-hidden='true'>" +
        " RS_PRODUCT_SHIPPING_GET_IT_BY_LABEL " +
        "<span class='rsGetItBy'></span>" +
        "</span>" +
        "<span class='rsShippingOrderWithinWrapper rsHidden' aria-hidden='true'>" +
        " RS_PRODUCT_SHIPPING_ORDER_BY_LABEL " +
        "<span class='rsOrderWithin'></span>" +
        "</span>" +
        "</div>"
      i.qt(r, ".rsShippingContainer", e)
    }
  }
  Rs.tn = function (r) {
    var d = r
    var f = function (r) {
      d.Wr(r, ".rsLoadingMessage")
      d.Wr(r, ".rsPriceWrapper")
      d.Wr(r, ".rsPriceRangeWrapper")
      d.Wr(r, ".rsFreeShippingTransitDays")
      d.Wr(r, ".rsFreeShippingTransitDaysLabel")
      d.Wr(r, ".rsFreeNDayShippingWrapper")
      d.Wr(r, ".rsInventoryLowStockQuantityWrapper")
      d.Wr(r, ".rsInventoryOutOfStockPreorder")
      d.Wr(r, ".rsInventoryOutOfStock")
      d.Wr(r, ".rsShippingEstimateWrapper")
      d.Wr(r, ".rsShippingGetItByWrapper")
      d.Wr(r, ".rsShippingOrderWithinWrapper")
      d.Wr(r, ".rsErrorMessage")
      d.Wr(r, ".rsElectronicDelivery")
      d.Wr(r, ".rsDropshipDelivery")
      d.Wr(r, ".rsAffirmProductMessage")
    }
    this.mn = function (r, e) {
      var t = r.In,
        i = r.On,
        n,
        s
      f(e)
      if (r.vn === r.Rn) {
        d.Yr(e, ".rsPrice", "$" + r.vn)
        d.Hr(e, ".rsPriceWrapper")
      } else {
        d.Yr(e, ".rsMinPrice", "$" + r.vn)
        d.Yr(e, ".rsMaxPrice", "$" + r.Rn)
        d.Hr(e, ".rsPriceRangeWrapper")
      }
      if (r.Nn && typeof affirm !== "undefined") {
        var a = d.Gr(e, ".rsAffirmProductMessage")
        if (a) {
          a.setAttribute("data-amount", r.vn * 100)
          if (!a.hasAttribute("data-page-type")) {
            a.setAttribute("data-page-type", "category")
          }
          a.classList.add("affirm-as-low-as")
          affirm["ui"].ready(function () {
            affirm["ui"].refresh()
          })
          d.Hr(e, ".rsAffirmProductMessage")
        }
      }
      if (r.Tn) {
        return
      }
      if (r.An) {
        d.Hr(e, ".rsElectronicDelivery")
        return
      }
      if (t) {
        n = new t.context.qi(t.productDataObj)
        s = n.xi()
        if (!t["productDataObj"]["shippingOptions"]["best"]["isDs"]) {
          const u = n.Vi()
          if (u) {
            d.Yr(e, ".rsOrderWithin", u)
            d.Hr(e, ".rsShippingOrderWithinWrapper")
          }
          d.Yr(e, ".rsGetItBy", s)
          d.Hr(e, ".rsShippingEstimateWrapper")
          d.Hr(e, ".rsShippingGetItByWrapper")
        } else {
          d.Hr(e, ".rsDropshipDelivery")
        }
        if (!t.productDataObj["shippingOptions"]["best"]["cost"]) {
          var o = n.ki(),
            l = d.Gr(e, ".rsFreeShippingTransitDaysLabel")
          if (o) {
            d.Yr(e, ".rsFreeShippingTransitDays", o)
            d.Hr(e, ".rsFreeShippingTransitDays")
            d.Hr(l)
            d.Hr(e, ".rsFreeNDayShippingWrapper")
          } else if (l) {
            d.Hr(e, ".rsFreeNDayShippingWrapper")
          }
        }
        if (r.En) {
          d.Yr(e, ".rsLowStockQuantity", r.En)
          d.Hr(e, ".rsInventoryLowStockQuantityWrapper")
        }
        return
      }
      if (r.hn && d.Gr(e, ".rsFreeShippingTransitDaysLabel")) {
        d.Hr(e, ".rsFreeNDayShippingWrapper")
      }
      d.Hr(
        e,
        r.Sn ? ".rsInventoryOutOfStockPreorder" : ".rsInventoryOutOfStock"
      )
      if (i) {
        n = new i.context.qi(i.productDataObj)
        s = n.xi()
        d.Yr(e, ".rsGetItBy", s)
        d.Hr(e, ".rsShippingEstimateWrapper")
        d.Hr(e, ".rsShippingGetItByWrapper")
      }
    }
    this.nn = function (r, e) {
      f(r)
      if (typeof e === "undefined") {
        e = true
      }
      if (e) {
        d.Hr(r, ".rsErrorMessage")
      }
    }
  }
  Rs.t(function () {
    var t = function (r, e) {
      var t = document.querySelectorAll(r)
      if (t.length !== 0) {
        for (var i = 0; i < t.length; i++) {
          t[i].dispatchEvent(Rs.Events.createEvent(e))
        }
      }
    }
    var r = function (r, e) {
      t(r, e)
      Rs.o.l(r, e)
    }
    try {
      var e = new Rs.Ri(Rs.Kr, Rs._n.validate, new Rs.Zr()),
        i = new Rs.Ci(),
        n = new Rs.Ji(e, i),
        s = new Rs.Se()
      e.Ti(false)
      document.addEventListener(
        Rs.Events.POPULATE_PRODUCT_OFFER_CONTAINER,
        function (r) {
          n.$i(r.target)
        }
      )
      document.addEventListener(
        Rs.Events.POPULATE_PRODUCT_AGGREGATE_CONTAINER,
        function (r) {
          n.en(r.target)
        }
      )
      document.addEventListener(
        Rs.Events.HIDE_IF_ITEM_UNORDERABLE,
        function (r) {
          n.ln(r.target)
        }
      )
      document.addEventListener(
        Rs.Events.INITIALIZE_CHANGE_ITEM_FORM,
        function (r) {
          n.fn(r.target)
        }
      )
      document.addEventListener(Rs.Events.ZIP_CODE_UPDATED, function () {
        t(
          ".rsProductOfferContainer",
          Rs.Events.POPULATE_PRODUCT_OFFER_CONTAINER
        )
        t(
          ".rsProductAggregateContainer",
          Rs.Events.POPULATE_PRODUCT_AGGREGATE_CONTAINER
        )
      })
      document.addEventListener(
        Rs.Events.PRODUCT_OFFER_CONTAINER_CART_FORM_ADDED,
        function (r) {
          s.Ee(r.target)
        }
      )
      document.addEventListener(
        Rs.Events.POPULATE_NOTIFY_ME_MODAL_CONTAINER,
        function (r) {
          n.pn(r.target)
        }
      )
      document.addEventListener(
        Rs.Events.INITIALIZE_NOTIFY_ME_MODAL,
        function (r) {
          i.Re(r.target)
        }
      )
      r(".rsProductOfferContainer", Rs.Events.POPULATE_PRODUCT_OFFER_CONTAINER)
      r(
        ".rsProductAggregateContainer",
        Rs.Events.POPULATE_PRODUCT_AGGREGATE_CONTAINER
      )
      r(".rsHideIfItemUnorderable", Rs.Events.HIDE_IF_ITEM_UNORDERABLE)
      r(".rsChangeItemForm", Rs.Events.INITIALIZE_CHANGE_ITEM_FORM)
      r(".rsAddToCartForm", Rs.Events.PRODUCT_OFFER_CONTAINER_CART_FORM_ADDED)
      r(
        ".rsNotifyMeModalContainer",
        Rs.Events.POPULATE_NOTIFY_ME_MODAL_CONTAINER
      )
      r(".rsNotifyMeModalWrapper", Rs.Events.INITIALIZE_NOTIFY_ME_MODAL)
      document.addEventListener(
        Rs.Events.UPDATE_PRODUCT_OFFER_CONTAINER_WITH_NEW_ITEM,
        function (r) {
          n.dn(r.target, r["newItemId"], r["newItemUrl"])
        }
      )
      if (typeof window["onRsProductApiClientReady"] === "function") {
        window.onRsProductApiClientReady(new Rs.hi(e, s))
      }
      e.flush()
      e.Ti(true)
    } catch (r) {
      var a = {}
      a["source"] = "productController"
      a["caughtError"] = r
      a["fullHtmlDump"] = document.documentElement.outerHTML
      Rs.Qr.send(Rs.p._, a)
    }
  })
  let webIdEventName = "ftr:customerWebIdReady"
  let webIdCallback = function (webId) {
    var xhr = new XMLHttpRequest()
    var formData = new FormData()
    formData.append("forter-web-id", webId)
    xhr.open(
      "POST",
      "https://shop.skbcases.com/attach-forter-web-id-to-session-ajax",
      true
    )
    xhr.withCredentials = true
    xhr.send(formData)
  }

  let jqueryFunc = window["jQuery"] || window["$"]
  if (typeof jqueryFunc === "function") {
    jqueryFunc(document).on(webIdEventName, function (e, webId) {
      webIdCallback(webId)
    })
  } else {
    document.addEventListener(webIdEventName, function (e) {
      webIdCallback(e.detail)
    })
  }

  ;(function () {
    var merchantConfig = {
      csp: false,
    }

    var siteId = "6a9829d4b13d"
    function t(t, n) {
      for (var e = t.split(""), r = 0; r < e.length; ++r)
        e[r] = String.fromCharCode(e[r].charCodeAt(0) + n)
      return e.join("")
    }
    function n(n) {
      return t(n, -L).replace(/%SN%/g, siteId)
    }
    function e() {
      var t = "no" + "op" + "fn",
        n = "g" + "a",
        e = "n" + "ame"
      return window[n] && window[n][e] === t
    }
    function r() {
      return !(!navigator.brave || "function" != typeof navigator.brave.isBrave)
    }
    function o() {
      return document.currentScript && document.currentScript.src
    }
    function i(t) {
      try {
        if (
          "number" == typeof t &&
          window.location &&
          window.location.pathname
        ) {
          for (
            var n = window.location.pathname.split("/"), e = [], r = 0;
            r <= Math.min(n.length - 1, Math.abs(t));
            r++
          )
            e.push(n[r])
          return e.join("/") || "/"
        }
      } catch (t) {}
      return "/"
    }
    function c(t) {
      try {
        ;(G.ex = t),
          e() && -1 === G.ex.indexOf(B.uB) && (G.ex += B.uB),
          r() && -1 === G.ex.indexOf(B.uBr) && (G.ex += B.uBr),
          o() && -1 === G.ex.indexOf(B.nIL) && (G.ex += B.nIL),
          window.ftr__snp_cwc || (G.ex += B.s),
          q(G)
      } catch (t) {}
    }
    function a(t, n) {
      function e(o) {
        try {
          o.blockedURI === t && (n(), document.removeEventListener(r, e))
        } catch (t) {
          document.removeEventListener(r, e)
        }
      }
      var r = "securitypolicyviolation"
      document.addEventListener(r, e),
        setTimeout(function () {
          document.removeEventListener(r, e)
        }, 2 * 60 * 1e3)
    }
    function u(t, n, e, r) {
      var o = !1
      ;(t = "https://" + t),
        a(t, function () {
          r(!0), (o = !0)
        })
      var i = document.createElement("script")
      ;(i.onerror = function () {
        if (!o)
          try {
            r(!1), (o = !0)
          } catch (t) {}
      }),
        (i.onload = e),
        (i.type = "text/javascript"),
        (i.id = "ftr__script"),
        (i.async = !0),
        (i.src = t)
      var c = document.getElementsByTagName("script")[0]
      c.parentNode.insertBefore(i, c)
    }
    function f(t, n, e, r) {
      var o = !1,
        i = new XMLHttpRequest()
      if (
        (a("https:" + t, function () {
          e(new Error("CSP Violation"), !0), (o = !0)
        }),
        "//" === t.slice(0, 2) && (t = "https:" + t),
        "withCredentials" in i)
      )
        i.open("GET", t, !0)
      else {
        if ("undefined" == typeof XDomainRequest) return
        ;(i = new XDomainRequest()), i.open("GET", t)
      }
      Object.keys(r).forEach(function (t) {
        i.setRequestHeader(t, r[t])
      }),
        (i.onload = function () {
          "function" == typeof n && n(i)
        }),
        (i.onerror = function (t) {
          if ("function" == typeof e && !o)
            try {
              e(t, !1), (o = !0)
            } catch (t) {}
        }),
        (i.onprogress = function () {}),
        (i.ontimeout = function () {
          "function" == typeof e && e("tim" + "eo" + "ut", !1)
        }),
        setTimeout(function () {
          i.send()
        }, 0)
    }
    function d(t, siteId, n) {
      function e(t) {
        var n = t.toString(16)
        return n.length % 2 ? "0" + n : n
      }
      function r(t) {
        if (t <= 0) return ""
        for (var n = "0123456789abcdef", e = "", r = 0; r < t; r++)
          e += n[Math.floor(Math.random() * n.length)]
        return e
      }
      function o(t) {
        for (var n = "", r = 0; r < t.length; r++) n += e(t.charCodeAt(r))
        return n
      }
      function i(t) {
        for (var n = t.split(""), e = 0; e < n.length; ++e)
          n[e] = String.fromCharCode(255 ^ n[e].charCodeAt(0))
        return n.join("")
      }
      n = n ? "1" : "0"
      var c = []
      return (
        c.push(t),
        c.push(siteId),
        c.push(n),
        (function (t) {
          var n = 40,
            e = ""
          return (
            t.length < n / 2 && (e = "," + r(n / 2 - t.length - 1)), o(i(t + e))
          )
        })(c.join(","))
      )
    }
    function s() {
      function t() {
        b && (z(B.dUAL), setTimeout(w, I, B.dUAL))
      }
      function n(t, n) {
        c(n ? B.uAS + B.uF + B.cP : B.uAS + B.uF)
      }
      window.ftr__fdad(t, n)
    }
    function w(t) {
      try {
        var n = t === B.uDF ? E : b
        if (!n) return
        u(
          n,
          void 0,
          function () {
            try {
              $(), c(t + B.uS)
            } catch (t) {}
          },
          function (n) {
            try {
              $(),
                (G.td = 1 * new Date() - G.ts),
                c(n ? t + B.uF + B.cP : t + B.uF),
                t === B.uDF && s()
            } catch (t) {
              c(B.eUoe)
            }
          }
        )
      } catch (n) {
        c(t + B.eTlu)
      }
    }
    var h = "22g5o{trgtes|:f51forxgiurqw1qhw2vwdwxv",
      v = "fort",
      m = "erTo",
      l = "ken"
    window.ftr__config = { m: merchantConfig, s: "20", si: siteId }
    var p = !1,
      g = v + m + l,
      _ = 400 * 24 * 60,
      y = 10,
      T = {
        write: function (t, n, e, r) {
          void 0 === r && (r = !0)
          var o = 0
          window.ftr__config &&
            window.ftr__config.m &&
            window.ftr__config.m.ckDepth &&
            (o = window.ftr__config.m.ckDepth)
          var c,
            a,
            u = i(o)
          if (
            (e
              ? ((c = new Date()),
                c.setTime(c.getTime() + 60 * e * 1e3),
                (a = "; expires=" + c.toGMTString()))
              : (a = ""),
            !r)
          )
            return void (document.cookie =
              escape(t) + "=" + escape(n) + a + "; path=" + u)
          for (
            var f = 1, d = document.domain.split("."), s = y, w = !0;
            w && d.length >= f && s > 0;

          ) {
            var h = d.slice(-f).join(".")
            document.cookie =
              escape(t) + "=" + escape(n) + a + "; path=" + u + "; domain=" + h
            var v = T.read(t)
            ;(null != v && v == n) ||
              ((h = "." + h),
              (document.cookie =
                escape(t) +
                "=" +
                escape(n) +
                a +
                "; path=" +
                u +
                "; domain=" +
                h)),
              (w = -1 === document.cookie.indexOf(t + "=" + n)),
              f++,
              s--
          }
        },
        read: function (t) {
          var n = null
          try {
            for (
              var e = escape(t) + "=",
                r = document.cookie.split(";"),
                o = 32,
                i = 0;
              i < r.length;
              i++
            ) {
              for (var c = r[i]; c.charCodeAt(0) === o; )
                c = c.substring(1, c.length)
              0 === c.indexOf(e) &&
                (n = unescape(c.substring(e.length, c.length)))
            }
          } finally {
            return n
          }
        },
      },
      S = window.ftr__config.s
    S += "ck"
    var x = function (t) {
        var n = !1,
          e = null,
          r = function () {
            try {
              if (!e || !n) return
              e.remove && "function" == typeof e.remove
                ? e.remove()
                : document.head.removeChild(e),
                (n = !1)
            } catch (t) {}
          }
        document.head &&
          (!(function () {
            ;(e = document.createElement("link")),
              e.setAttribute("rel", "pre" + "con" + "nect"),
              e.setAttribute("cros" + "sori" + "gin", "anonymous"),
              (e.onload = r),
              (e.onerror = r),
              e.setAttribute("href", t),
              document.head.appendChild(e),
              (n = !0)
          })(),
          setTimeout(r, 3e3))
      },
      L = 3,
      k = n(h || "22g5o{trgtes|:f51forxgiurqw1qhw2vwdwxv"),
      A = t("[0Uhtxhvw0LG", -L),
      U = t("[0Fruuhodwlrq0LG", -L),
      D = t("Li0Qrqh0Pdwfk", -L),
      b,
      C = "fgq71iruwhu1frp",
      E = n("(VQ(1" + C + "2vq2(VQ(2vfulsw1mv"),
      F = n("(VQ(1" + C + "2vqV2(VQ(2vfulsw1mv"),
      I = 10
    window.ftr__startScriptLoad = 1 * new Date()
    var V = function (t) {
        var n = "ft" + "r:tok" + "enR" + "eady"
        window.ftr__tt && clearTimeout(window.ftr__tt),
          (window.ftr__tt = setTimeout(function () {
            try {
              delete window.ftr__tt, (t += "_tt")
              var e = document.createEvent("Event")
              e.initEvent(n, !1, !1), (e.detail = t), document.dispatchEvent(e)
            } catch (t) {}
          }, 1e3))
      },
      q = function (t) {
        var n = function (t) {
            return t || ""
          },
          e =
            n(t.id) +
            "_" +
            n(t.ts) +
            "_" +
            n(t.td) +
            "_" +
            n(t.ex) +
            "_" +
            n(S),
          r = _
        !isNaN(window.ftr__config.m.ckTTL) &&
          window.ftr__config.m.ckTTL &&
          (r = window.ftr__config.m.ckTTL),
          T.write(g, e, r, !0),
          V(e),
          (window.ftr__gt = e)
      },
      R = function () {
        var t = T.read(g) || "",
          n = t.split("_"),
          e = function (t) {
            return n[t] || void 0
          }
        return { id: e(0), ts: e(1), td: e(2), ex: e(3), vr: e(4) }
      },
      M = (function () {
        for (var t = {}, n = "fgu", e = [], r = 0; r < 256; r++)
          e[r] = (r < 16 ? "0" : "") + r.toString(16)
        var o = function (t, n, r, o, i) {
            var c = i ? "-" : ""
            return (
              e[255 & t] +
              e[(t >> 8) & 255] +
              e[(t >> 16) & 255] +
              e[(t >> 24) & 255] +
              c +
              e[255 & n] +
              e[(n >> 8) & 255] +
              c +
              e[((n >> 16) & 15) | 64] +
              e[(n >> 24) & 255] +
              c +
              e[(63 & r) | 128] +
              e[(r >> 8) & 255] +
              c +
              e[(r >> 16) & 255] +
              e[(r >> 24) & 255] +
              e[255 & o] +
              e[(o >> 8) & 255] +
              e[(o >> 16) & 255] +
              e[(o >> 24) & 255]
            )
          },
          i = function () {
            if (
              window.Uint32Array &&
              window.crypto &&
              window.crypto.getRandomValues
            ) {
              var t = new window.Uint32Array(4)
              return (
                window.crypto.getRandomValues(t),
                { d0: t[0], d1: t[1], d2: t[2], d3: t[3] }
              )
            }
            return {
              d0: (4294967296 * Math.random()) >>> 0,
              d1: (4294967296 * Math.random()) >>> 0,
              d2: (4294967296 * Math.random()) >>> 0,
              d3: (4294967296 * Math.random()) >>> 0,
            }
          },
          c = function () {
            var t = "",
              n = function (t, n) {
                for (var e = "", r = t; r > 0; --r)
                  e += n.charAt((1e3 * Math.random()) % n.length)
                return e
              }
            return (
              (t += n(2, "0123456789")),
              (t += n(1, "123456789")),
              (t += n(8, "0123456789"))
            )
          }
        return (
          (t.safeGenerateNoDash = function () {
            try {
              var t = i()
              return o(t.d0, t.d1, t.d2, t.d3, !1)
            } catch (t) {
              try {
                return n + c()
              } catch (t) {}
            }
          }),
          (t.isValidNumericalToken = function (t) {
            return (
              t &&
              t.toString().length <= 11 &&
              t.length >= 9 &&
              parseInt(t, 10).toString().length <= 11 &&
              parseInt(t, 10).toString().length >= 9
            )
          }),
          (t.isValidUUIDToken = function (t) {
            return t && 32 === t.toString().length && /^[a-z0-9]+$/.test(t)
          }),
          (t.isValidFGUToken = function (t) {
            return 0 == t.indexOf(n) && t.length >= 12
          }),
          t
        )
      })(),
      B = {
        uDF: "UDF",
        dUAL: "dUAL",
        uAS: "UAS",
        mLd: "1",
        eTlu: "2",
        eUoe: "3",
        uS: "4",
        uF: "9",
        tmos: ["T5", "T10", "T15", "T30", "T60"],
        tmosSecs: [5, 10, 15, 30, 60],
        bIR: "43",
        uB: "u",
        uBr: "b",
        cP: "c",
        nIL: "i",
        s: "s",
      }
    try {
      var G = R()
      try {
        G.id &&
        (M.isValidNumericalToken(G.id) ||
          M.isValidUUIDToken(G.id) ||
          M.isValidFGUToken(G.id))
          ? (window.ftr__ncd = !1)
          : ((G.id = M.safeGenerateNoDash()), (window.ftr__ncd = !0)),
          (G.ts = window.ftr__startScriptLoad),
          q(G),
          (window.ftr__snp_cwc = !!T.read(g)),
          window.ftr__snp_cwc || (E = F)
        for (
          var N = "for" + "ter" + ".co" + "m",
            O = "ht" + "tps://c" + "dn9." + N,
            j = "ht" + "tps://" + G.id + "-" + siteId + ".cd" + "n." + N,
            H = "http" + "s://cd" + "n3." + N,
            P = [O, j, H],
            Q = 0;
          Q < P.length;
          Q++
        )
          x(P[Q])
        var X = new Array(B.tmosSecs.length),
          z = function (t) {
            for (var n = 0; n < B.tmosSecs.length; n++)
              X[n] = setTimeout(c, 1e3 * B.tmosSecs[n], t + B.tmos[n])
          },
          $ = function () {
            for (var t = 0; t < B.tmosSecs.length; t++) clearTimeout(X[t])
          }
        ;(window.ftr__fdad = function (n, e) {
          if (!p) {
            p = !0
            var r = {}
            ;(r[D] = d(window.ftr__config.s, siteId, window.ftr__config.m.csp)),
              f(
                k,
                function (e) {
                  try {
                    var r = e.getAllResponseHeaders().toLowerCase()
                    if (r.indexOf(U.toLowerCase()) >= 0) {
                      var o = e.getResponseHeader(U)
                      window.ftr__altd2 = t(atob(o), -L - 1)
                    }
                    if (r.indexOf(A.toLowerCase()) < 0) return
                    var i = e.getResponseHeader(A),
                      c = t(atob(i), -L - 1)
                    if (c) {
                      var a = c.split(":")
                      if (a && 2 === a.length) {
                        for (
                          var u = a[0], f = a[1], d = "", s = 0, w = 0;
                          s < 20;
                          ++s
                        )
                          d +=
                            s % 3 > 0 && w < 12
                              ? siteId.charAt(w++)
                              : G.id.charAt(s)
                        var h = f.split(",")
                        if (h.length > 1) {
                          var v = h[0],
                            m = h[1]
                          b = u + "/" + v + "." + d + "." + m
                        }
                      }
                    }
                    n()
                  } catch (t) {}
                },
                function (t, n) {
                  e && e(t, n)
                },
                r
              )
          }
        }),
          z(B.uDF),
          setTimeout(w, I, B.uDF)
      } catch (t) {
        c(B.mLd)
      }
    } catch (t) {}
  })()
}